webpackJsonp([5],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


// export const apiURL = 'http://localhost:8080'
// export const apiURL = 'http://165.227.43.245/api'
var apiURL = 'https://changeriskassessment.changevu.com/api';

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(26);
var _this = this;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  return new Promise(function (resolve) {
    _this.app.$once('scrollAfterEnter', function () {
      if (savedPosition) {
        resolve(savedPosition);
      } else {
        resolve({ x: 0, y: 0 });
      }
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'hash',
  linkActiveClass: 'is-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    name: 'ProgressBar',
    path: '/progressBar',
    component: __webpack_require__(170)
  }, {
    name: 'OnBoard',
    path: '/onBoard',
    component: __webpack_require__(165)
  }, {
    name: 'OnBoardMember',
    path: '/onBoardMember/:userID',
    component: __webpack_require__(166)
  }, {
    name: 'Login',
    path: '/login',
    component: __webpack_require__(164)
  }, {
    name: 'ForgotPassword',
    path: '/forgotPassword',
    component: __webpack_require__(163)
  }, {
    name: 'Contact Us',
    path: '/contactUs',
    component: __webpack_require__(169)
  }, {
    name: 'Terms of Service',
    path: '/terms',
    component: __webpack_require__(172)
  }, {
    name: 'Assessment Dashboard',
    path: '/home',
    component: __webpack_require__(159)
  }, {
    name: 'Sample Meeting Agenda',
    path: '/agenda',
    component: __webpack_require__(158)
  }, {
    name: 'My Change Risk Assessment',
    path: '/ChangeRiskAssessment',
    component: __webpack_require__(162)
  }, {
    name: 'Account Setting',
    path: '/accountSetting',
    component: __webpack_require__(160)
  }, {
    name: 'Manage Team Member(s)',
    path: '/teamInfo',
    component: __webpack_require__(171)
  }, {
    name: 'Manage Assessment',
    path: '/assessmentInfo',
    component: __webpack_require__(161)
  }, {
    name: 'Reset Password',
    path: '/resetPassword/:token',
    component: __webpack_require__(167)
  }, {
    name: 'ChangeVU Admin',
    path: '/admin',
    component: __webpack_require__(168)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: '*',
    redirect: '/home'
  }])
}));

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SWITCH_EFFECT; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lazyLoading__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reports__ = __webpack_require__(209);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var state = {
  items: [{
    name: 'Assessment Dashboard',
    path: '/home',
    meta: {
      icon: 'fa-eye',
      link: 'Home'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('home', true)
  }, {
    name: 'My Change Risk Assessment',
    path: '/ChangeRiskAssessment',
    meta: {
      icon: 'fa fa-adjust',
      link: 'assessment/riskAssessment'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('assessment', true)
  }, __WEBPACK_IMPORTED_MODULE_2__reports__["a" /* default */], {
    name: 'Sample Meeting Agenda',
    path: '/agenda',
    meta: {
      icon: 'fa-file-pdf-o',
      link: 'Agenda'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('agenda', true)
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(177)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(295)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(354),
  /* scopeId */
  "data-v-000c80f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)
__webpack_require__(312)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  "data-v-5c432ed7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(326)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(301)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  "data-v-19967256",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(296)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  "data-v-04e956b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(365),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  "data-v-cda19f0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)
__webpack_require__(324)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  "data-v-cdb0e7d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  "data-v-4f37f5d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(368),
  /* scopeId */
  "data-v-379c9a58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(374),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  "data-v-57a82ec8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(297)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(356),
  /* scopeId */
  "data-v-095724a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(369),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(201);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/footerLogo.c8646e2.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(304)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  "data-v-1f0bd79c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Agenda.vue": [
		158
	],
	"./Home.vue": [
		159
	],
	"./accountSetting/AccountSetting.vue": [
		160
	],
	"./assessment/assessmentInfo.vue": [
		161
	],
	"./assessment/myReport.vue": [
		401,
		0
	],
	"./assessment/riskAssessment.vue": [
		162
	],
	"./assessment/teamReportByAverage.vue": [
		402,
		2
	],
	"./assessment/teamReportByVariance.vue": [
		403,
		1
	],
	"./auth/ForgotPassword.vue": [
		163
	],
	"./auth/Login.vue": [
		164
	],
	"./auth/OnBoard.vue": [
		165
	],
	"./auth/OnBoardMember.vue": [
		166
	],
	"./auth/ResetPassword.vue": [
		167
	],
	"./changeVuAdmin/admin.vue": [
		168
	],
	"./contactUs/ContactUs.vue": [
		169
	],
	"./progressBar.vue": [
		170
	],
	"./requestDemo/RequestDemo.vue": [
		404,
		3
	],
	"./teamMember/teamMembers.vue": [
		171
	],
	"./terms/tos.vue": [
		172
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 177;

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nprogress__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__globalConstants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuejs_dialog__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuejs_noty__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuejs_noty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuejs_noty__);
/* unused harmony reexport router */
/* unused harmony reexport store */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



__WEBPACK_IMPORTED_MODULE_1_es6_promise___default.a.polyfill(); // Check Browser compatibility and make them equal










// import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vuejs_dialog___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vuejs_noty___default.a, {
  theme: 'metroui',
  timeout: 3000,
  closeWith: ['click'],
  progressBar: false,
  layout: 'topCenter'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', {
  inserted: function inserted(el) {
    var onMobile = window.innerWidth < 767;
    if (!onMobile) {
      el.focus();
    }
  },
  update: function update(el) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
      var onMobile = window.innerWidth < 767;
      if (!onMobile) {
        el.focus();
      }
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth___default.a, {
  auth: {
    request: function request(req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
    },
    response: function response(res) {
      var token = res.data.token;
      if (token) {
        return token;
      }
    }
  },
  http: __webpack_require__(178),
  router: __webpack_require__(179),
  loginData: { url: __WEBPACK_IMPORTED_MODULE_13__globalConstants__["a" /* apiURL */] + '/auth/local', fetchUser: false },
  fetchData: { url: __WEBPACK_IMPORTED_MODULE_13__globalConstants__["a" /* apiURL */] + '/auth/local', method: 'GET', enabled: true },
  refreshData: { enabled: false },
  tokenStore: ['localStorage', 'cookie'],
  rolesVar: 'role'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_12_moment___default()(String(value)).format('MM-DD-YYYY');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate2', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_12_moment___default()(String(value)).format('MMMM DD, YYYY');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default.a);

// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default.a({ parent: '.nprogress-container' });

// const { state } = store

__WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].beforeEach(function (route, redirect, next) {
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 100);
  var user = window.localStorage.getItem('user');
  if (route.path === '/admin') {
    if (user) {
      user = JSON.parse(user);
      if (user.role === 'superAdmin') {
        next();
      } else {
        next({ path: '/home' });
      }
    }
  } else if (route.path.indexOf('/onBoardMember') !== -1) {
    next();
  } else if (route.path === '/onBoard') {
    next();
  } else {
    if (route.path.indexOf('/login') !== -1 || route.path.indexOf('/resetPassword') !== -1 || route.path.indexOf('/forgotPassword') !== -1 || route.path.indexOf('/requestDemo') !== -1 || route.path.indexOf('/terms') !== -1) {
      next();
    } else {
      if (!user) {
        next({ path: '/onBoard' });
      } else {
        next();
      }
    }
  }
});

Object.keys(__WEBPACK_IMPORTED_MODULE_11__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_11__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_8__App_vue___default.a));



/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tableComponent__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tableComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tableComponent__);
/* unused harmony reexport tableComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabParentComponent__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabParentComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tabParentComponent__);
/* unused harmony reexport tabParentComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tabChildComponent__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tabChildComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tabChildComponent__);
/* unused harmony reexport tabChildComponent */















/***/ }),
/* 203 */
/***/ (function(module, exports) {



/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(10);


var toggleSidebar = function toggleSidebar(_ref, config) {
  var commit = _ref.commit;

  if (config instanceof Object) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_SIDEBAR */], config);
  }
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};



/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_app__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_menu__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_initiative__ = __webpack_require__(208);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_4__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_5__modules_menu__["a" /* default */],
    initiative: __WEBPACK_IMPORTED_MODULE_6__modules_initiative__["a" /* default */]
  },
  state: {
    userImageSrc: '',
    clientLogoSrc: '',
    assessmentCompleted: false,
    currentInitiativeName: '',
    currentInitiativeTeamName: '',
    currentInitiativeTeamLead: '',
    currentUserName: '',
    activeInitiative: false,
    statusBar: 'The diagnostic will be automatically submitted on Oct. 19th, 2017'
  },
  mutations: {
    setUserImageSrc: function setUserImageSrc(state, val) {
      state.userImageSrc = val;
    },
    setClientLogoSrc: function setClientLogoSrc(state, val) {
      state.clientLogoSrc = val;
    },
    setAssessmentCompleted: function setAssessmentCompleted(state, val) {
      state.assessmentCompleted = val;
    },
    setCurrentInitiativeName: function setCurrentInitiativeName(state, val) {
      state.currentInitiativeName = val;
    },
    setCurrentInitiativeTeamName: function setCurrentInitiativeTeamName(state, val) {
      state.currentInitiativeTeamName = val;
    },
    setCurrentInitiativeTeamLead: function setCurrentInitiativeTeamLead(state, val) {
      state.currentInitiativeTeamLead = val;
    },
    setCurrentUserName: function setCurrentUserName(state, val) {
      state.currentUserName = val;
    },
    activeInitiativeMethod: function activeInitiativeMethod(state) {
      state.activeInitiative = true;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(10);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_SIDEBAR */], function (state, config) {
  if (config.hasOwnProperty('opened')) {
    state.sidebar.opened = config.opened;
  }

  if (config.hasOwnProperty('hidden')) {
    state.sidebar.hidden = config.hidden;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// active initiative
var state = {
  Phase: '' // Mobilise, Assess, Design, Implement, Sustain
};

var mutations = {
  setPhase: function setPhase(state, val) {
    state.Phase = val;
  },
  setSuccessProfileRisks: function setSuccessProfileRisks(state, val) {
    state.successProfileRisk[val.index] = val.risk;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Change Risk Dashboard',
  meta: {
    icon: 'fa-pie-chart',
    expanded: true
  },

  children: [{
    name: 'My Change Risk Report',
    path: '/assessment/myReport',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('assessment/myReport'),
    meta: {
      icon: 'fa fa-line-chart',
      link: 'assessment/myReport'
    }
  }, {
    name: 'Risks by Team Average',
    path: '/assessment/teamReportByAverage',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('assessment/teamReportByAverage'),
    meta: {
      icon: 'fa fa-area-chart',
      link: 'assessment/teamReportByAverage'
    }
  }, {
    name: 'Risks by Team Variance',
    path: '/assessment/teamReportByVariance',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('assessment/teamReportByVariance'),
    meta: {
      icon: 'fa fa-bar-chart',
      link: 'assessment/teamReportByVariance'
    }
  }]
});

/***/ }),
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(202);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a
  },
  data: function data() {
    return {
      sidebar: this.onResize
    };
  },
  created: function created() {
    this.onResize();
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },

  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        this.sidebar = false;
      } else {
        this.sidebar = true;
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        this.sidebar = false;
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {},
  methods: {
    afterEnter: function afterEnter() {
      this.$root.$emit('scrollAfterEnter');
    }
  },
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    // console.log(this.$router.currentRoute)
    this.getList();
  },


  computed: {
    msgToUser: function msgToUser() {
      return '';
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/home' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_scss_navbar_scss__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_scss_navbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_scss_navbar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters, mapActions } from 'vuex'





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ['show', 'sidebar', 'expand'],
  data: function data() {
    return {
      modalOpen: false,
      apiUrl: __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */],
      showOutNav: false,
      showNav: false,
      hover: false,
      user: '',
      upgrade: {
        name: '',
        email: '',
        info: '',
        message: ''
      },
      sidebarOpen: this.expand
    };
  },
  created: function created() {
    var _this = this;

    var user = JSON.parse(window.localStorage.getItem('user'));
    if (user) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/auth/local').then(function (response) {
        if (response.data.profilePicture) {
          _this.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/' + response.data.profilePicture);
        } else {
          _this.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'extra-large.jpg');
        }
        if (response.data.logoPath) {
          _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/' + response.data.logoPath);
        } else {
          _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'changeVULogo.png');
        }
        _this.$store.commit('setCurrentUserName', response.data.firstName + ' ' + response.data.lastName);
        _this.$store.commit('setAssessmentCompleted', response.data.diagonacticStatus);
        _this.upgrade.email = response.data.email;
        _this.upgrade.firstName = response.data.firstName;
        _this.upgrade.lastName = response.data.lastName;
      }).catch(function (error) {
        _this.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'extra-large.jpg');
        _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'changeVULogo.png');
        console.log(error);
      });
    }
  },

  computed: {
    userImageSrc: function userImageSrc() {
      return this.$store.state.userImageSrc;
    },
    clientLogoSrc: function clientLogoSrc() {
      return this.$store.state.clientLogoSrc;
    },
    currentUserName: function currentUserName() {
      return this.$store.state.currentUserName;
    }
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
      this.$emit('update:sidebar', this.sidebarOpen);
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        if (this.showNav) {
          this.showNav = false;
        }
      }
    },
    userMenuToggle: function userMenuToggle() {
      this.showNav = !this.showNav;
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        if (this.sidebarOpen) {
          this.sidebarOpen = false;
          this.$emit('update:sidebar', this.sidebarOpen);
        }
      }
    },
    logout: function logout() {
      window.localStorage.removeItem('Initiative');
      window.localStorage.removeItem('user');
      this.$cookie.delete('role');
      this.$cookie.delete('token');
      this.$auth.logout({
        makeRequest: false,
        success: function success() {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/login' });
        }
      });
    },
    openModal: function openModal() {
      this.modalOpen = true;
      this.showNav = false;
    },
    closeModal: function closeModal() {
      this.modalOpen = false;
      this.upgrade.info = '';
      this.upgrade.message = '';
    },
    addHover: function addHover() {
      this.hover = true;
    },
    removeHover: function removeHover() {
      this.hover = false;
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    submitUpgrade: function submitUpgrade() {
      var _this2 = this;

      if (!this.validateEmail(this.upgrade.email)) {
        this.$noty.error('Please enter valid email address.');
        this.upgrade.email = '';
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/api/v1/upgradeToPro', { name: this.upgrade.firstName + ' ' + this.upgrade.lastName, email: this.upgrade.email, topic: this.upgrade.info, details: this.upgrade.message }).then(function (response) {
          _this2.modalOpen = false;
          _this2.upgrade.info = '';
          _this2.upgrade.message = '';
          _this2.$noty.success('Thanks for connecting with us. We will get back to you as soon as possible.');
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.showNav = false;
      this.showOutNav = false;
      this.hover = false;
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        this.sidebarOpen = false;
        this.$emit('update:sidebar', this.sidebarOpen);
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.$on('update:sidebar', function (newVal) {
      _this3.sidebarOpen = newVal;
    });
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },
  props: ['sidebar', 'sidebarShow'],
  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menu: 'menuitems'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    },
    sidebarShow: function sidebarShow(newVal, oldVal) {
      this.$root.$emit('update:sidebar', newVal);
    }
  }

});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      required: true
    },
    selected: {
      default: false
    },
    prefix: { default: '' },
    suffix: { default: '' }
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  computed: {
    header: function header() {
      return this.prefix + this.name + this.suffix;
    }
  },
  mounted: function mounted() {
    this.isActive = this.selected;
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tabs: []
    };
  },
  created: function created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab: function selectTab(selectedTab) {
      this.tabs.forEach(function (tab) {
        tab.isActive = selectedTab.name === tab.name;
        console.log(tab.isActive);
      });
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    data: Array,
    columns: Array,
    average: Array,
    averageColumn: Array,
    showtable: String
  },
  data: function data() {
    var sortOrders = {};
    this.columns.forEach(function (key) {
      sortOrders[key] = 1;
    });
    return {
      clicked: true,
      colorTrue: false,
      sortKey: '',
      sortOrders: sortOrders
    };
  },
  computed: {
    filteredData: function filteredData() {
      var sortKey = this.sortKey;
      var order = this.sortOrders[sortKey] || 1;
      var data = this.data;
      // console.log('1')
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return data;
    }
  },
  filters: {
    capitalize: function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
    sortBy: function sortBy(key) {
      if (key === 'Your Score' || key === 'Baseline Score' || key === 'Baseline+ Score' || key === 'Risk Priority' || key === 'Priority') {
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      }
    },
    showSortIcon: function showSortIcon() {
      this.clicked = false;
    },

    GetRiskColor: function GetRiskColor(riskValue) {
      if (riskValue > 0 && riskValue <= 3) {
        return 'colorGreen';
      } else if (riskValue > 3 && riskValue <= 6) {
        return 'colorYellow';
      } else if (riskValue > 6 && riskValue <= 9) {
        return 'colorRed';
      } else {
        return 'colorDefault';
      }
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_2_vue_datetime__["Datetime"],
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      fullPage: true,
      isLoading: true,
      modalOpen: false,
      notVisited: true,
      previewModalOpen: false,
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        type: '',
        role: '',
        Submitted: false
      },
      client: {
        id: '',
        companyName: '',
        contactPerson: {
          firstName: '',
          lastName: '',
          email: '',
          role: ''
        }
      },
      initiative: {
        id: '',
        name: '',
        deadline: '',
        teamName: '',
        initiativeDetails: '',
        members: []
      },
      sortedMembers: [],
      showInitiative: false,
      pictureName: '',
      data: {
        labels: ['Invited', 'Pending', 'Submitted'],
        datasets: [{
          data: [0, 0, 0],
          backgroundColor: ['#b5b5b5', '#fce473', '#6666ff']
        }]
      },
      options: {
        title: {
          display: true,
          text: 'Team Member Assessment Status'
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              stepSize: 2
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: 10,
              fontStyle: 600
            },
            barPercentage: 0.5
          }]
        }
      },
      invitedNo: 0,
      PendingNo: 0,
      CompletedNo: 0
    };
  },

  computed: {
    chartData: function chartData() {
      this.data.datasets[0].data[0] = this.invitedNo;
      this.data.datasets[0].data[1] = this.PendingNo;
      this.data.datasets[0].data[2] = this.CompletedNo;
      return this.data;
    }
  },
  created: function created() {
    var _this = this;

    var isVisited = JSON.parse(window.localStorage.getItem('visited'));
    if (isVisited && isVisited.status) {
      this.notVisited = false;
    } else {
      window.localStorage.setItem('visited', JSON.stringify({ status: true }));
    }
    var user = JSON.parse(window.localStorage.getItem('user'));
    this.user = user;
    this.user.Submitted = user.diagonacticStatus;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/createdInitiatives/' + user._id).then(function (response) {
      if (response.data.length > 0) {
        _this.initiative.id = response.data[0]._id;
        _this.initiative.teamLead = response.data[0].teamLead.firstName + ' ' + response.data[0].teamLead.lastName;
        _this.initiative.teamName = response.data[0].teamName;
        _this.initiative.name = response.data[0].initiativeName;
        _this.initiative.deadline = new Date(response.data[0].deadline).toLocaleString();
        _this.initiative.members = response.data[0].members;
        _this.initiative.initiativeDetails = response.data[0].initiativeDescription;
        // not joined, status 1
        var notJoined = 0;
        for (var j = 0; j < _this.initiative.members.length; j++) {
          if (!_this.initiative.members[j].user.joining) {
            _this.sortedMembers.push({ 'member': _this.initiative.members[j].user.email, 'role': 'TM', 'status': 1, 'action': true, 'id': _this.initiative.members[j].user._id });
            notJoined++;
          }
        }
        // Assessment pending, status 2
        var assessmentPending = 0;
        for (var _j = 0; _j < _this.initiative.members.length; _j++) {
          if (_this.initiative.members[_j].user.joining && !_this.initiative.members[_j].user.diagonacticCompleted) {
            var role = 'TM';
            var action = true;
            if (_this.initiative.members[_j].user.type === 'companyAdmin') {
              role = 'TL';
              action = false;
            }
            _this.sortedMembers.push({ 'member': _this.initiative.members[_j].user.firstName + ' ' + _this.initiative.members[_j].user.lastName + '\n' + ' (' + _this.initiative.members[_j].user.email + ')', 'role': role, 'status': 2, 'action': action, 'id': _this.initiative.members[_j].user._id });
            assessmentPending++;
          }
        }
        // Assessment complete, status 3
        var assessmentComplete = 0;
        for (var _j2 = 0; _j2 < _this.initiative.members.length; _j2++) {
          if (_this.initiative.members[_j2].user.joining && _this.initiative.members[_j2].user.diagonacticCompleted) {
            var _role = 'TM';
            if (_this.initiative.members[_j2].user.type === 'companyAdmin') {
              _role = 'TL';
            }
            _this.sortedMembers.push({ 'member': _this.initiative.members[_j2].user.firstName + ' ' + _this.initiative.members[_j2].user.lastName + '\n' + ' (' + _this.initiative.members[_j2].user.email + ')', 'role': _role, 'status': 3, 'action': false, 'id': _this.initiative.members[_j2].user._id });
            assessmentComplete++;
          }
        }
        // update chart
        _this.invitedNo = notJoined + assessmentPending + assessmentComplete;
        _this.PendingNo = assessmentPending;
        _this.CompletedNo = assessmentComplete;
        _this.data.datasets[0].data[0] = _this.invitedNo;
        _this.data.datasets[0].data[1] = _this.PendingNo;
        _this.data.datasets[0].data[2] = _this.CompletedNo;
        window.localStorage.setItem('Initiative', JSON.stringify({ id: response.data[0]._id }));
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + user._id).then(function (response1) {
          _this.$store.commit('setAssessmentCompleted', response1.data.diagonacticCompleted);
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients/' + response1.data.client).then(function (response2) {
            _this.client.companyName = response2.data.companyName;
            _this.client.contactPerson = response2.data.contactPerson;
            _this.client.id = response2.data._id;
            if (response2.data.logoPath) {
              _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/' + response2.data.logoPath);
            }
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function (error) {
          console.log(error);
        });
      }
      _this.isLoading = false;
    }).catch(function (error) {
      if (error.response.status === 401) {
        _this.logout();
      }
    });
  },

  methods: {
    logout: function logout() {
      window.localStorage.removeItem('Initiative');
      window.localStorage.removeItem('user');
      this.$cookie.delete('role');
      this.$cookie.delete('token');
      this.$auth.logout({
        makeRequest: false,
        success: function success() {
          __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ path: '/login' });
        }
      });
    },
    fileChange: function fileChange() {
      var image = document.getElementById('logo').files[0];
      this.pictureName = image.name;
    },
    editInitiative: function editInitiative() {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ path: '/assessmentInfo' });
    },
    closeNotVisited: function closeNotVisited() {
      this.notVisited = !this.notVisited;
    },
    previewModal: function previewModal() {
      this.previewModalOpen = !this.previewModalOpen;
    },
    closePreviewModal: function closePreviewModal() {
      this.previewModalOpen = !this.previewModalOpen;
    },
    remind: function remind(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/remind', { inviter: this.user, 'initiativeID': this.initiative.id, 'userID': item.id }).then(function (response) {
        console.log(response);
        _this2.$noty.success('Reminder sent successfully.');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_data__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_form_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__["b" /* TabPane */]
  },
  data: function data() {
    return {
      oldPassword: '',
      newPassword: '',
      rePassword: '',
      user: '',
      userInfo: {
        firstName: '',
        lastName: '',
        email: '',
        role: ''
      },
      pictureName: ''
    };
  },
  created: function created() {
    var _this = this;

    // console.log(window.localStorage.getItem('user'))
    var user = JSON.parse(window.localStorage.getItem('user'));
    this.user = user;
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + user._id).then(function (response) {
      _this.userInfo.firstName = response.data.firstName;
      _this.userInfo.lastName = response.data.lastName;
      _this.userInfo.email = response.data.email;
      _this.userInfo.role = response.data.role;
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    fileChange: function fileChange() {
      var image = document.getElementById('profilePicture').files[0];
      this.pictureName = image.name;
    },
    editUser: function editUser() {
      var _this2 = this;

      var image = document.getElementById('profilePicture').files[0];
      var fd = new __WEBPACK_IMPORTED_MODULE_3_form_data___default.a();
      fd.append('file', image);
      if (this.userInfo.firstName === '') {
        this.$noty.error('Please enter First Name.');
      } else if (this.userInfo.lastName === '') {
        this.$noty.error('Please enter Last Name.');
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, this.userInfo).then(function (response) {
          _this2.$noty.success('Profile updated Successfully.');
          if (image) {
            if (_this2.user.role === 'companyAdmin') {
              fd.append('profilePictureFlag', 1);
            }
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + _this2.user._id + '/upload', fd, {
              headers: { 'Content-Type': undefined }
            }).then(function (response) {
              _this2.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/' + response.data.path);
              _this2.pictureName = '';
              _this2.$noty.success('Profile picture updated Successfully.');
            }).catch(function (error) {
              console.log(error);
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    validatePassword: function validatePassword(newPassword) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      return re.test(newPassword);
    },
    changePassword: function changePassword() {
      var _this3 = this;

      if (this.oldPassword === '') {
        this.$noty.error('Please enter old password.');
      } else if (this.newPassword === '') {
        this.$noty.error('Please enter new password.');
      } else if (!this.validatePassword(this.newPassword)) {
        this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.');
      } else if (this.rePassword === '') {
        this.$noty.error('Please retype new password.');
      } else if (this.newPassword !== this.rePassword) {
        this.$noty.error('Password did not match!!');
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { oldPassword: this.oldPassword, newPassword: this.newPassword }).then(function (response) {
          if (response.data.error) {
            _this3.$noty.error(response.data.error);
            _this3.oldPassword = '';
            _this3.newPassword = '';
            _this3.rePassword = '';
          } else {
            _this3.$noty.success('Password changed successfully.');
            _this3.oldPassword = '';
            _this3.newPassword = '';
            _this3.rePassword = '';
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_data__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_form_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_form_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_2_vue_datetime__["Datetime"]
  },
  data: function data() {
    return {
      fullPage: true,
      isLoading: true,
      modalOpen: false,
      notVisited: true,
      previewModalOpen: false,
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        type: '',
        role: '',
        Submitted: false
      },
      client: {
        id: '',
        companyName: '',
        contactPerson: {
          firstName: '',
          lastName: '',
          email: '',
          role: ''
        }
      },
      initiative: {
        id: '',
        name: '',
        deadline: '',
        teamName: '',
        initiativeDetails: '',
        members: []
      },
      pictureName: ''
    };
  },
  created: function created() {
    this.loadData();
  },

  methods: {
    fileChange: function fileChange() {
      var image = document.getElementById('logo').files[0];
      this.pictureName = image.name;
    },
    submit: function submit() {
      var _this = this;

      if (this.client.companyName === undefined || this.client.companyName === null || this.client.companyName.trim() === '') {
        this.$noty.error('Please enter your organization name.');
      } else if (this.initiative.teamName === undefined || this.initiative.teamName === null || this.initiative.teamName.trim() === '') {
        this.$noty.error('Please enter your team name.');
      } else if (this.initiative.name === undefined || this.initiative.name === null || this.initiative.name.trim() === '') {
        this.$noty.error('Please enter initiative name.');
      } else if (this.initiative.deadline === undefined || this.initiative.deadline === null || this.initiative.deadline.trim() === '') {
        this.$noty.error('Please set a deadline for the risk assessment.');
      } else {
        this.initiative.deadline = new Date(this.initiative.deadline).toUTCString();
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/initiatives/' + this.initiative.id, { initiativeName: this.initiative.name, teamName: this.initiative.teamName, initiativeDescription: this.initiative.initiativeDetails, deadline: this.initiative.deadline }).then(function (response1) {
          _this.initiative.deadline = new Date(_this.initiative.deadline).toLocaleString();
          var image = document.getElementById('logo').files[0];
          if (image) {
            var fd = new __WEBPACK_IMPORTED_MODULE_3_form_data___default.a();
            fd.append('file', image, 'file');
            fd.append('clientId', true);
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + _this.client.id + '/upload', fd, {
              headers: { 'Content-Type': undefined }
            }).then(function (response) {
              _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/' + response.data.path);
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients/' + _this.client.id, { companyName: _this.client.companyName, logoPath: response.data.logoPath }).then(function (response) {
                _this.$noty.success('Logo updated successfully.');
              }).catch(function (error) {
                console.log('error on saving client' + error.response.data.message);
              });
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            console.log('just ' + _this.client.companyName);
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients/' + _this.client.id, { companyName: _this.client.companyName }).then(function (response) {
              console.log(response);
            }).catch(function (error) {
              console.log('error on saving client' + error.response.data.message);
            });
          }
          _this.$noty.success('Assessment updated successfully.');
        }).catch(function (error) {
          _this.$noty.error(error.response.data.message);
          console.log('error on saving initiative' + error);
        });
      }
    },
    loadData: function loadData() {
      var _this2 = this;

      var user = JSON.parse(window.localStorage.getItem('user'));
      this.user = user;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/createdInitiatives/' + user._id).then(function (response) {
        if (response.data.length > 0) {
          _this2.initiative.id = response.data[0]._id;
          _this2.initiative.teamLead = response.data[0].teamLead.firstName + ' ' + response.data[0].teamLead.lastName;
          _this2.initiative.teamName = response.data[0].teamName;
          _this2.initiative.name = response.data[0].initiativeName;
          _this2.initiative.deadline = new Date(response.data[0].deadline).toLocaleString();
          _this2.initiative.members = response.data[0].members;
          _this2.initiative.initiativeDetails = response.data[0].initiativeDescription;

          window.localStorage.setItem('Initiative', JSON.stringify({ id: response.data[0]._id }));
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + user._id).then(function (response1) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients/' + response1.data.client).then(function (response2) {
              _this2.client.companyName = response2.data.companyName;
              _this2.client.contactPerson = response2.data.contactPerson;
              _this2.client.id = response2.data._id;
              if (response2.data.logoPath) {
                _this2.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/' + response2.data.logoPath);
              }
            }).catch(function (error) {
              console.log(error);
            });
          }).catch(function (error) {
            console.log(error);
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_scss_diagnostic_scss__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_scss_diagnostic_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assets_scss_diagnostic_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_slider__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globalConstants_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_slider___default.a
  },
  props: {
    value: String
  },
  data: function data() {
    return {
      modalOpen: false,
      user: '',
      totalSteps: 16,
      currentStep: 1,
      step: 1,
      error: null,
      randomQuestion: [],
      risks: [{
        question: 'One sponsor has been clearly identified and is driving (or continues to drive) the Initiative/Project(s)',
        score: '',
        subcategory: 'identifySponsor'
      }, {
        question: 'We have completed and communicated a business case that describes the Initiative/Project(s) including costs, benefits, rationale, interfaces, deliverables and milestones & timing for installation and adoption or uptake',
        score: '',
        subcategory: 'visionClarity'
      }, {
        question: 'A clear line of accountability exists from lead Sponsor Project leaders, sufficient to deliver in the time frame envisioned over the lifespan of the implementation',
        score: '',
        subcategory: 'sponsoringCoalition'
      }, {
        question: 'We have the appropriate and required change skills in key leadership roles to deliver the Initiative/Project(s)',
        score: '',
        subcategory: 'sponsorCapability'
      }, {
        question: 'Our Initiative/Project(s) has the right Governance in place to ensure successful implementation (including steering and other supporting committees, decision-making criteria and process)',
        score: '',
        subcategory: 'governance'
      }, {
        question: 'Our Program Office is fit-for-purpose to manage the implementation of the Initiative/Project(s) effectively (including staffing, skills, tools, resources and other project-specific support infrastructure)',
        score: '',
        subcategory: 'programmeManagement'
      }, {
        question: 'We have all relevant Financing, Costing, Budgeting and allocation of Resources secured for the entire Initiative/Project(s) (including specialized skill-sets, variable, part-time and contract resources)',
        score: '',
        subcategory: 'budgetingandResourcing'
      }, {
        question: 'Our Program delivery resourcing (including variable and part-time, contract staffing, etc.) and infrastructure is appropriate for the various needs of the Initiative/Project for all stages of implementation',
        score: '',
        subcategory: 'programmeDelivery'
      }, {
        question: 'Our Initiative/Project(s) fits/is fully aligned with the existing business strategy and overall business goals of our organization',
        score: '',
        subcategory: 'businessRequirements'
      }, {
        question: 'We have a clear description and definition of the "end state"/outcome of the Initiative/Project(s) in place (including organization design criteria, measurables, metrics & activities) ',
        score: '',
        subcategory: 'organizationDesign'
      }, {
        question: 'We have the appropriate Change Readiness resources, skills and support in place to drive the activities, interventions, meetings and coordination to  support effective implementation of the Initiative/Project(s)',
        score: '',
        subcategory: 'changeReadiness'
      }, {
        question: 'We have specific, differentiated communication activities for individual target communities in place (including role during various implementation phases, business impact, outcome, timeline etc.)',
        score: '',
        subcategory: 'implementationPlanning'
      }, {
        question: 'We have the required experience and skills for leading the change in key management & supervisory positions for the Initiative/Project(s) in place',
        score: '',
        subcategory: 'changeLeadership'
      }, {
        question: "Our key Stakeholder Engagement plan & process for Engagement with all key stakeholders (external and internal) fits the requirements to successfully deliver the Initiative/Project(s) over it's life-span",
        score: '',
        subcategory: 'stakeholderEngagement'
      }, {
        question: 'We have the appropriate resourcing of skills and capabilities for people-related Change Management and Engagement in place',
        score: '',
        subcategory: 'implementationCapability'
      }, {
        question: 'We have planned, resourced and are ready to deliver all the support and relevant materials required to ensure all impacted employees and other stakeholders (internal and external) are enabled to make the required Change and Transformation',
        score: '',
        subcategory: 'supportPeoplesJournery'
      }],
      identifySponsor: '',
      visionClarity: '',
      sponsoringCoalition: '',
      sponsorCapability: '',
      governance: '',
      programmeManagement: '',
      budgetingandResourcing: '',
      programmeDelivery: '',
      businessRequirements: '',
      organizationDesign: '',
      changeReadiness: '',
      implementationPlanning: '',
      changeLeadership: '',
      stakeholderEngagement: '',
      implementationCapability: '',
      supportPeoplesJournery: '',
      isSubmitted: this.$store.state.assessmentCompleted
    };
  },

  methods: {
    prev: function prev() {
      this.currentStep--;
      this.step = this.randomQuestion[this.currentStep - 1];
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    next: function next() {
      this.currentStep++;
      this.step = this.randomQuestion[this.currentStep - 1];
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    submit: function submit() {
      var _this = this;

      var allDone = false;
      if (parseFloat(this.identifySponsor) > 0 && parseFloat(this.identifySponsor) < 10 && parseFloat(this.visionClarity) > 0 && parseFloat(this.visionClarity) < 10 && parseFloat(this.sponsoringCoalition) > 0 && parseFloat(this.sponsoringCoalition) < 10 && parseFloat(this.sponsorCapability) > 0 && parseFloat(this.sponsorCapability) < 10 && parseFloat(this.governance) > 0 && parseFloat(this.governance) < 10 && parseFloat(this.programmeManagement) > 0 && parseFloat(this.programmeManagement) < 10 && parseFloat(this.budgetingandResourcing) > 0 && parseFloat(this.budgetingandResourcing) < 10 && parseFloat(this.programmeDelivery) > 0 && parseFloat(this.programmeDelivery) < 10 && parseFloat(this.businessRequirements) > 0 && parseFloat(this.businessRequirements) < 10 && parseFloat(this.organizationDesign) > 0 && parseFloat(this.organizationDesign) < 10 && parseFloat(this.changeReadiness) > 0 && parseFloat(this.changeReadiness) < 10 && parseFloat(this.implementationPlanning) > 0 && parseFloat(this.implementationPlanning) < 10 && parseFloat(this.changeLeadership) > 0 && parseFloat(this.changeLeadership) < 10 && parseFloat(this.stakeholderEngagement) > 0 && parseFloat(this.stakeholderEngagement) < 10 && parseFloat(this.implementationCapability) > 0 && parseFloat(this.implementationCapability) < 10 && parseFloat(this.supportPeoplesJournery) > 0 && parseFloat(this.supportPeoplesJournery) < 10) {
        allDone = true;
      }
      if (allDone) {
        var message = 'You can not change your assessment score once submitted. Are you sure you want to submit this score?';
        var options = {
          loader: true,
          okText: 'Yes, submit my score',
          cancelText: 'No, do not submit my score',
          customClass: 'dg-diagnostics'
        };
        this.$dialog.confirm(message, options).then(function (dialog) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/checkAllDone/' + _this.initiativeId, { userID: _this.user._id }).then(function (response) {
            _this.$store.commit('setAssessmentCompleted', true);
            dialog.close();
            _this.modalOpen = true;
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function () {});
      } else {
        this.$noty.info('You must enter all change risk factors to complete this assessment.');
      }
    },
    closeModal: function closeModal() {
      this.modalOpen = false;
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/assessment/myReport' });
    },
    update1: function update1(val) {
      var _this2 = this;

      this.identifySponsor = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 0 }).then(function (response) {
        _this2.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this2.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update2: function update2(val) {
      var _this3 = this;

      this.visionClarity = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 1 }).then(function (response) {
        _this3.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this3.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update3: function update3(val) {
      var _this4 = this;

      this.sponsoringCoalition = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 2 }).then(function (response) {
        _this4.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this4.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update4: function update4(val) {
      var _this5 = this;

      this.sponsorCapability = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 3 }).then(function (response) {
        _this5.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this5.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update5: function update5(val) {
      var _this6 = this;

      this.governance = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 4 }).then(function (response) {
        _this6.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this6.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update6: function update6(val) {
      var _this7 = this;

      this.programmeManagement = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 5 }).then(function (response) {
        _this7.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this7.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update7: function update7(val) {
      var _this8 = this;

      this.budgetingandResourcing = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 6 }).then(function (response) {
        _this8.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this8.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update8: function update8(val) {
      var _this9 = this;

      this.programmeDelivery = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 7 }).then(function (response) {
        _this9.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this9.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update9: function update9(val) {
      var _this10 = this;

      this.businessRequirements = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 8 }).then(function (response) {
        _this10.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this10.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update10: function update10(val) {
      var _this11 = this;

      this.organizationDesign = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 9 }).then(function (response) {
        _this11.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this11.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update11: function update11(val) {
      var _this12 = this;

      this.changeReadiness = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 10 }).then(function (response) {
        _this12.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this12.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update12: function update12(val) {
      var _this13 = this;

      this.implementationPlanning = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 11 }).then(function (response) {
        _this13.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this13.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update13: function update13(val) {
      var _this14 = this;

      this.changeLeadership = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 12 }).then(function (response) {
        _this14.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this14.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update14: function update14(val) {
      var _this15 = this;

      this.stakeholderEngagement = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 13 }).then(function (response) {
        _this15.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this15.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update15: function update15(val) {
      var _this16 = this;

      this.implementationCapability = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 14 }).then(function (response) {
        _this16.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this16.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    update16: function update16(val) {
      var _this17 = this;

      this.supportPeoplesJournery = val;
      if (isNaN(val)) {
        val = '0';
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user._id, { initiativeId: this.initiativeId, riskValue: val, index: 15 }).then(function (response) {
        _this17.user.diagonactics = response.data.diagonactics;
        window.localStorage.setItem('user', JSON.stringify(_this17.user));
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    var _this18 = this;

    var user = JSON.parse(window.localStorage.getItem('user'));
    this.user = user;
    this.isSubmitted = this.$store.state.assessmentCompleted;
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + user._id).then(function (response) {
      _this18.isSubmitted = response.data.diagonacticCompleted;
      _this18.$store.commit('setAssessmentCompleted', response.data.diagonacticCompleted);
    }).catch(function (error) {
      if (error.response.status === 401) {
        _this18.logout();
      }
    });
    var currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'));
    this.initiativeId = currentInitiative.id;
    var diagonactic = void 0;
    if (currentInitiative) {
      for (var i = 0; i < user.diagonactics.length; i++) {
        if (user.diagonactics[i].initiative === currentInitiative.id) {
          diagonactic = user.diagonactics[i];
          break;
        }
      }
      if (diagonactic) {
        this.identifySponsor = diagonactic.risks[0] === '0' ? '' : diagonactic.risks[0];
        this.visionClarity = diagonactic.risks[1] === '0' ? '' : diagonactic.risks[1];
        this.sponsoringCoalition = diagonactic.risks[2] === '0' ? '' : diagonactic.risks[2];
        this.sponsorCapability = diagonactic.risks[3] === '0' ? '' : diagonactic.risks[3];
        this.governance = diagonactic.risks[4] === '0' ? '' : diagonactic.risks[4];
        this.programmeManagement = diagonactic.risks[5] === '0' ? '' : diagonactic.risks[5];
        this.budgetingandResourcing = diagonactic.risks[6] === '0' ? '' : diagonactic.risks[6];
        this.programmeDelivery = diagonactic.risks[7] === '0' ? '' : diagonactic.risks[7];
        this.businessRequirements = diagonactic.risks[8] === '0' ? '' : diagonactic.risks[8];
        this.organizationDesign = diagonactic.risks[9] === '0' ? '' : diagonactic.risks[9];
        this.changeReadiness = diagonactic.risks[10] === '0' ? '' : diagonactic.risks[10];
        this.implementationPlanning = diagonactic.risks[11] === '0' ? '' : diagonactic.risks[11];
        this.changeLeadership = diagonactic.risks[12] === '0' ? '' : diagonactic.risks[12];
        this.stakeholderEngagement = diagonactic.risks[13] === '0' ? '' : diagonactic.risks[13];
        this.implementationCapability = diagonactic.risks[14] === '0' ? '' : diagonactic.risks[14];
        this.supportPeoplesJournery = diagonactic.risks[15] === '0' ? '' : diagonactic.risks[15];
      } else {}
    }
    // randomize the steps
    function shuffle(array) {
      var currentIndex = array.length;
      var temporaryValue = void 0;
      var randomIndex = void 0;
      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    }
    this.randomQuestion = shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]);
    this.step = this.randomQuestion[0]; // show the initial random Q
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import router from '../../router'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: ''
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      console.log(this.email);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/forgot', { email: this.email }).then(function (response) {
        if (response.data.error) {
          _this.$noty.error('User not found');
        } else if (response.data.message === 'Email Sent') {
          console.log(response.data.token);
          _this.$noty.success('Password reset link has been sent to your email.');
          _this.email = '';
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import postData from '../../assets/data/data.json'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showForm: false,
      user: {
        email: '',
        password: '',
        rememberMe: false
      },
      error: null
    };
  },
  mounted: function mounted() {
    if (this.$auth.redirect()) {
      console.log('Redirect from: ' + this.$auth.redirect().from.name);
    }
  },

  methods: {
    login: function login() {
      if (this.user.email === '') {
        this.$noty.error('Please enter email address.');
      } else if (this.user.password === '') {
        this.$noty.error('Password can not be blank');
      } else {
        this.$auth.login({
          url: __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/auth/local',
          body: this.user,
          success: function success(res) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/auth/local').then(function (response) {
              _this.$cookie.set('token', res.data.token);
              _this.$cookie.set('role', response.data.role);
              if (response.data.profilePicture) {
                _this.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/' + response.data.profilePicture);
              } else {
                _this.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'extra-large.jpg');
              }
              if (response.data.logoPath) {
                _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/' + response.data.logoPath);
              } else {
                _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_2__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'changeVULogo.png');
              }
              _this.$store.commit('setCurrentUserName', response.data.firstName + ' ' + response.data.lastName);
              if (response.data.currentInitiative) {
                // set current initiative data
                _this.$store.commit('setCurrentInitiativeName', response.data.currentInitiative.initiativeName);
                _this.$store.commit('setCurrentInitiativeTeamName', response.data.currentInitiative.teamName);
                if (response.data.currentInitiative.teamLead) {
                  _this.$store.commit('setCurrentInitiativeTeamLead', response.data.currentInitiative.teamLead.firstName + ' ' + response.data.currentInitiative.teamLead.lastName);
                }
                _this.$store.commit('setCurrentInitiativeImplementationStage', response.data.currentInitiative.implementationStage);

                window.localStorage.setItem('Initiative', JSON.stringify({ id: response.data.currentInitiative._id, name: response.data.currentInitiative.initiativeName }));
              }
              window.localStorage.setItem('user', JSON.stringify(response.data));

              // following code needs to optimized
              var user = JSON.parse(window.localStorage.getItem('user'));
              _this.user = user;
              var currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'));
              _this.currentInitiative = currentInitiative;
              var diagonactic = void 0;
              if (currentInitiative) {
                for (var i = 0; i < user.diagonactics.length; i++) {
                  if (user.diagonactics[i].initiative === currentInitiative.id) {
                    diagonactic = user.diagonactics[i];
                    break;
                  }
                }
              }
              if (diagonactic) {
                _this.$store.commit('setIdentifySponsor', diagonactic.risks[0] ? diagonactic.risks[0] : '');
                _this.$store.commit('setVisionClarity', diagonactic.risks[1] ? diagonactic.risks[1] : '');
                _this.$store.commit('setSponsoringCoalition', diagonactic.risks[2] ? diagonactic.risks[2] : '');
                _this.$store.commit('setSponsorCapability', diagonactic.risks[3] ? diagonactic.risks[3] : '');
                _this.$store.commit('setGovernance', diagonactic.risks[4] ? diagonactic.risks[4] : '');
                _this.$store.commit('setProgrammeManagement', diagonactic.risks[5] ? diagonactic.risks[5] : '');
                _this.$store.commit('setBudgetingandResourcing', diagonactic.risks[6] ? diagonactic.risks[6] : '');
                _this.$store.commit('setProgrammeDelivery', diagonactic.risks[7] ? diagonactic.risks[7] : '');
                _this.$store.commit('setBusinessRequirements', diagonactic.risks[8] ? diagonactic.risks[8] : '');
                _this.$store.commit('setOrganizationDesign', diagonactic.risks[9] ? diagonactic.risks[9] : '');
                _this.$store.commit('setChangeReadiness', diagonactic.risks[10] ? diagonactic.risks[10] : '');
                _this.$store.commit('setImplementationPlanning', diagonactic.risks[11] ? diagonactic.risks[11] : '');
                _this.$store.commit('setChangeLeadership', diagonactic.risks[12] ? diagonactic.risks[12] : '');
                _this.$store.commit('setStakeholderEngagement', diagonactic.risks[13] ? diagonactic.risks[13] : '');
                _this.$store.commit('setImplementationCapability', diagonactic.risks[14] ? diagonactic.risks[14] : '');
                _this.$store.commit('setSupportPeoplesJournery', diagonactic.risks[15] ? diagonactic.risks[15] : '');
              }

              if (response.data.role === 'superAdmin') {
                __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/admin' });
              } else {
                __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/home' });
              }
            }).catch(function (error) {
              console.log(error);
            });
          },
          data: this.user,
          error: function error() {},
          rememberMe: this.user.rememberMe,
          fetchUser: false
        });
      }
    }
  }

});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_scss_tooltip_scss__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_scss_tooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_scss_tooltip_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ofcold_security_code__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ofcold_security_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ofcold_security_code__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_6_vue_datetime__["Datetime"],
    Sms: __WEBPACK_IMPORTED_MODULE_8_ofcold_security_code___default.a
  },
  data: function data() {
    return {
      message: '',
      datePlaceholder: 'Set due date',
      modalOpen: false,
      contactModalOpen: false,
      step: 1,
      isInvited: false,
      verificationNumber: '',
      verificationDigits: '',
      user: {
        email: '',
        agree: false,
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        type: '',
        role: ''
      },
      client: {
        id: '',
        companyName: '',
        contactPerson: {
          firstName: '',
          lastName: '',
          email: '',
          role: ''
        }
      },
      initiative: {
        id: '',
        initiativeName: '',
        deadline: '',
        teamName: ''
      },
      members: [{
        email: ''
      }, {
        email: ''
      }, {
        email: ''
      }]
    };
  },
  mounted: function mounted() {},

  methods: {
    login: function login() {
      this.$auth.login({
        url: __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/auth/local',
        body: this.user,
        success: function success(res) {
          var _this = this;

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/auth/local').then(function (response) {
            _this.step++;
            _this.$cookie.set('token', res.data.token);
            _this.$cookie.set('role', response.data.role);
            _this.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'extra-large.jpg');
            _this.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'changeVULogo.png');
            _this.$store.commit('setCurrentUserName', response.data.firstName);
            window.localStorage.setItem('user', JSON.stringify(response.data));

            // following code needs to optimized
            var user = JSON.parse(window.localStorage.getItem('user'));
            _this.user = user;
            var currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'));
            _this.currentInitiative = currentInitiative;
            var diagonactic = void 0;
            if (currentInitiative) {
              for (var i = 0; i < user.diagonactics.length; i++) {
                if (user.diagonactics[i].initiative === currentInitiative.id) {
                  diagonactic = user.diagonactics[i];
                  break;
                }
              }
            }
            if (diagonactic) {
              _this.$store.commit('setIdentifySponsor', diagonactic.risks[0] ? diagonactic.risks[0] : '');
              _this.$store.commit('setVisionClarity', diagonactic.risks[1] ? diagonactic.risks[1] : '');
              _this.$store.commit('setSponsoringCoalition', diagonactic.risks[2] ? diagonactic.risks[2] : '');
              _this.$store.commit('setSponsorCapability', diagonactic.risks[3] ? diagonactic.risks[3] : '');
              _this.$store.commit('setGovernance', diagonactic.risks[4] ? diagonactic.risks[4] : '');
              _this.$store.commit('setProgrammeManagement', diagonactic.risks[5] ? diagonactic.risks[5] : '');
              _this.$store.commit('setBudgetingandResourcing', diagonactic.risks[6] ? diagonactic.risks[6] : '');
              _this.$store.commit('setProgrammeDelivery', diagonactic.risks[7] ? diagonactic.risks[7] : '');
              _this.$store.commit('setBusinessRequirements', diagonactic.risks[8] ? diagonactic.risks[8] : '');
              _this.$store.commit('setOrganizationDesign', diagonactic.risks[9] ? diagonactic.risks[9] : '');
              _this.$store.commit('setChangeReadiness', diagonactic.risks[10] ? diagonactic.risks[10] : '');
              _this.$store.commit('setImplementationPlanning', diagonactic.risks[11] ? diagonactic.risks[11] : '');
              _this.$store.commit('setChangeLeadership', diagonactic.risks[12] ? diagonactic.risks[12] : '');
              _this.$store.commit('setStakeholderEngagement', diagonactic.risks[13] ? diagonactic.risks[13] : '');
              _this.$store.commit('setImplementationCapability', diagonactic.risks[14] ? diagonactic.risks[14] : '');
              _this.$store.commit('setSupportPeoplesJournery', diagonactic.risks[15] ? diagonactic.risks[15] : '');
            }
          }).catch(function (error) {
            console.log(error);
          });
        },
        data: this.user
      });
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validatePassword: function validatePassword(password) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      return re.test(password);
    },
    onBoard: function onBoard(step) {
      var _this2 = this;

      if (step === 1) {
        if (this.user.email === undefined || this.user.email === null || this.user.email.trim() === '') {
          this.$noty.error('Please enter your email address.');
        } else if (this.user.agree === false) {
          this.$noty.error('Please accept our Terms of Use');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/onboardUser', { email: this.user.email }).then(function (response) {
            _this2.verificationNumber = response.data.number;
            _this2.step++;
          }).catch(function (error) {
            _this2.$noty.error(error.response.data.message);
          });
        }
      } else if (step === 2) {
        if (this.verificationDigits.toString() === undefined || this.verificationDigits.toString() === null || this.verificationDigits.toString() === '') {
          this.$noty.error('Please enter the verification code.');
        } else if (this.verificationNumber.toString() === this.verificationDigits.toString()) {
          this.user.type = 'companyAdmin';
          this.user.role = 'TL';
          this.step++;
        } else {
          this.$noty.error('Verification code did not match. Please check your email.');
        }
      } else if (step === 3) {
        if (this.user.firstName === undefined || this.user.firstName === null || this.user.firstName.trim() === '') {
          this.$noty.error('Please enter your first name.');
        } else if (this.user.lastName === undefined || this.user.lastName === null || this.user.lastName.trim() === '') {
          this.$noty.error('Please enter your last name.');
        } else if (this.user.password === undefined || this.user.password === null || this.user.password.trim() === '') {
          this.$noty.error('Please enter a password.');
        } else if (!this.validatePassword(this.user.password)) {
          this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.');
        } else if (this.user.confirmPassword === undefined || this.user.confirmPassword === null || this.user.confirmPassword.trim() === '') {
          this.$noty.error('Please confirm the password.');
        } else if (this.user.password !== this.user.confirmPassword) {
          this.$noty.error('Password and confirm password does not match.');
        } else {
          if (this.user.role) {
            this.user.role = 'TM';
          }
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users', { user: this.user }).then(function (response) {
            _this2.login();
            // this.step++ moved to login function
          }).catch(function (error) {
            console.log('error on saving users' + error);
            _this2.$noty.error(error.response.data.message);
          });
        }
      } else if (step === 4) {
        if (this.client.companyName === undefined || this.client.companyName === null || this.client.companyName.trim() === '') {
          this.$noty.error('Please enter your organization name.');
        } else if (this.initiative.teamName === undefined || this.initiative.teamName === null || this.initiative.teamName.trim() === '') {
          this.$noty.error('Please enter your team name.');
        } else if (this.initiative.initiativeName === undefined || this.initiative.initiativeName === null || this.initiative.initiativeName.trim() === '') {
          this.$noty.error('Please enter initiative name.');
        } else if (this.initiative.deadline === undefined || this.initiative.deadline === null || this.initiative.deadline.trim() === '') {
          this.$noty.error('Please set a deadline for the risk assessment.');
        } else {
          this.client.contactPerson.email = this.user.email;
          this.client.contactPerson.firstName = this.user.firstName;
          this.client.contactPerson.lastName = this.user.lastName;
          this.client.contactPerson.role = this.user.role;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients', this.client).then(function (response) {
            _this2.client.id = response.data.client._id;
            _this2.initiative.deadline = new Date(_this2.initiative.deadline).toUTCString();
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/initiatives', { initiative: _this2.initiative, userID: response.data.userId }).then(function (response1) {
              _this2.initiative.id = response1.data._id;
              _this2.initiative.deadline = new Date(response1.data.deadline).toLocaleString();
              _this2.step++;
            }).catch(function (error) {
              console.log('error on saving initiative' + error);
              _this2.$noty.error(error.response.data.message);
            });
          }).catch(function (error) {
            console.log('error on saving client' + error.response.data.message);
          });
        }
      } else if (step === 5) {
        var memberCount = 0;
        this.members.forEach(function (element) {
          if (element.email !== undefined && element.email !== null && element.email !== '') {
            if (!_this2.validateEmail(element.email)) {
              _this2.$noty.error('Please enter valid email address.');
              element.email = '';
            } else {
              memberCount++;
            }
          }
        });
        if (new Set(this.members).size !== this.members.length) {
          this.$noty.error('Please invite different members.');
        }
        if (memberCount > 2) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/invite', { inviter: this.user, members: this.members, initiativeID: this.initiative.id }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/home' });
          }).catch(function (error) {
            console.log('error on saving client' + error);
            _this2.$noty.error(error.response.data.message);
          });
        } else {
          this.$noty.error('Please invite at least three members to this risk assessment.');
        }
      }
    },
    prev: function prev() {
      this.step--;
    },
    add: function add(index) {
      this.members.push({ email: '' });
    },
    remove: function remove(index) {
      this.members.splice(index, 1);
    },
    previewModal: function previewModal() {
      this.modalOpen = true;
    },
    closeModal: function closeModal() {
      this.modalOpen = false;
    },
    contactModal: function contactModal() {
      this.contactModalOpen = true;
    },
    closeContactModal: function closeContactModal() {
      this.contactModalOpen = false;
      this.message = '';
    },
    contactSubmit: function contactSubmit() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/submitContactForm', { name: this.user.firstName + ' ' + this.user.lastName, email: this.user.email, details: this.message }).then(function (response) {
        _this3.contactModalOpen = false;
        _this3.message = '';
        _this3.$noty.success('Thanks for connecting with us. We will get back to you as soon as possible.');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      step: 1,
      isInvited: false,
      user: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        agree: false,
        type: '',
        role: ''
      },
      initiative: {
        id: '',
        initiativeName: '',
        deadline: '',
        teamName: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var path = this.$route.path;
    path = path.split('/');
    if (path[2]) {
      this.user.id = path[2];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + this.user.id).then(function (response) {
        _this.user.email = response.data.email;
      }).catch(function (error) {
        console.log('error on saving users' + error);
        _this.$noty.error(error.response.data.message);
      });
    }
  },

  methods: {
    login: function login() {
      this.$auth.login({
        url: __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/auth/local',
        body: this.user,
        success: function success(res) {
          var _this2 = this;

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/auth/local').then(function (response) {
            _this2.$cookie.set('token', res.data.token);
            _this2.$cookie.set('role', response.data.role);
            _this2.$store.commit('setUserImageSrc', __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'extra-large.jpg');
            _this2.$store.commit('setClientLogoSrc', __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/uploads/' + 'changeVULogo.png');
            _this2.$store.commit('setCurrentUserName', response.data.firstName);
            window.localStorage.setItem('user', JSON.stringify(response.data));

            // following code needs to optimized
            var user = JSON.parse(window.localStorage.getItem('user'));
            _this2.user = user;
            var currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'));
            _this2.currentInitiative = currentInitiative;
            var diagonactic = void 0;
            if (currentInitiative) {
              for (var i = 0; i < user.diagonactics.length; i++) {
                if (user.diagonactics[i].initiative === currentInitiative.id) {
                  diagonactic = user.diagonactics[i];
                  break;
                }
              }
            }
            if (diagonactic) {
              _this2.$store.commit('setIdentifySponsor', diagonactic.risks[0] ? diagonactic.risks[0] : '');
              _this2.$store.commit('setVisionClarity', diagonactic.risks[1] ? diagonactic.risks[1] : '');
              _this2.$store.commit('setSponsoringCoalition', diagonactic.risks[2] ? diagonactic.risks[2] : '');
              _this2.$store.commit('setSponsorCapability', diagonactic.risks[3] ? diagonactic.risks[3] : '');
              _this2.$store.commit('setGovernance', diagonactic.risks[4] ? diagonactic.risks[4] : '');
              _this2.$store.commit('setProgrammeManagement', diagonactic.risks[5] ? diagonactic.risks[5] : '');
              _this2.$store.commit('setBudgetingandResourcing', diagonactic.risks[6] ? diagonactic.risks[6] : '');
              _this2.$store.commit('setProgrammeDelivery', diagonactic.risks[7] ? diagonactic.risks[7] : '');
              _this2.$store.commit('setBusinessRequirements', diagonactic.risks[8] ? diagonactic.risks[8] : '');
              _this2.$store.commit('setOrganizationDesign', diagonactic.risks[9] ? diagonactic.risks[9] : '');
              _this2.$store.commit('setChangeReadiness', diagonactic.risks[10] ? diagonactic.risks[10] : '');
              _this2.$store.commit('setImplementationPlanning', diagonactic.risks[11] ? diagonactic.risks[11] : '');
              _this2.$store.commit('setChangeLeadership', diagonactic.risks[12] ? diagonactic.risks[12] : '');
              _this2.$store.commit('setStakeholderEngagement', diagonactic.risks[13] ? diagonactic.risks[13] : '');
              _this2.$store.commit('setImplementationCapability', diagonactic.risks[14] ? diagonactic.risks[14] : '');
              _this2.$store.commit('setSupportPeoplesJournery', diagonactic.risks[15] ? diagonactic.risks[15] : '');
            }
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: '/home' });
          }).catch(function (error) {
            console.log(error);
          });
        },
        data: this.user
      });
    },
    validatePassword: function validatePassword(password) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      return re.test(password);
    },
    onBoard: function onBoard() {
      var _this3 = this;

      if (this.user.firstName === undefined || this.user.firstName === null || this.user.firstName.trim() === '') {
        this.$noty.error('Please enter your first name.');
      } else if (this.user.lastName === undefined || this.user.lastName === null || this.user.lastName.trim() === '') {
        this.$noty.error('Please enter your last name.');
      } else if (this.user.password === undefined || this.user.password === null || this.user.password.trim() === '') {
        this.$noty.error('Please enter a password.');
      } else if (!this.validatePassword(this.user.password)) {
        this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.');
      } else if (this.user.confirmPassword === undefined || this.user.confirmPassword === null || this.user.confirmPassword.trim() === '') {
        this.$noty.error('Please confirm the password.');
      } else if (this.user.password !== this.user.confirmPassword) {
        this.$noty.error('Password and confirm password does not match.');
      } else if (this.user.agree === false) {
        this.$noty.error('Please accept our Terms of Use');
      } else {
        this.user.role = 'TM';
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users', { user: this.user }).then(function (response) {
          _this3.login();
        }).catch(function (error) {
          console.log('error on saving users' + error);
          _this3.$noty.error(error.response.data.message);
        });
      }
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      password: '',
      rePassword: ''
    };
  },

  methods: {
    validatePassword: function validatePassword(password) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      return re.test(password);
    },
    submitForm: function submitForm() {
      var _this = this;

      var path = this.$route.path;
      path = path.split('/');
      console.log(path[path.length - 1]);
      var token = path[path.length - 1];
      if (this.password === '') {
        this.$noty.error('Password can not be blank');
      } else if (!this.validatePassword(this.password)) {
        this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.');
      } else if (this.rePassword === '') {
        this.$noty.error('Retype Password can not be blank');
      } else if (this.password !== this.rePassword) {
        this.$noty.error('Password did not match');
        this.password = '';
        this.rePassword = '';
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/resetPassword/' + token, { password: this.password }).then(function (response) {
          if (response.data.error) {
            _this.$noty.error(response.data.error);
          } else {
            _this.password = '';
            _this.rePassword = '';
            _this.$noty.success('Password changed successfully.');
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: '/login' });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_form_data__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_form_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_form_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      modalOpen: false,
      onEditClient: {
        contactPerson: {},
        address: {}
      },
      client: {
        companyName: '',
        firstName: '',
        lastName: '',
        clientTitle: '',
        email: '',
        userRole: '',
        phone: '',
        country: '',
        city: '',
        code: '',
        street: '',
        url: '',
        logoPath: ''
      },
      logo: '',
      pictureName: '',
      pictureName2: '',
      isSubmitted: false,
      displayMsg: '',
      showForm: false,
      clients: []
    };
  },
  mounted: function mounted() {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients').then(function (response) {
      _this.clients = response.data;
      console.log(response);
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    fileChange: function fileChange() {
      var image = document.getElementById('logo').files[0];
      this.pictureName = image.name;
    },
    fileChange2: function fileChange2() {
      var image = document.getElementById('logo2').files[0];
      this.pictureName2 = image.name;
    },
    openModal: function openModal(item) {
      console.log(item);
      this.modalOpen = !this.modalOpen;
      this.onEditClient = item;
    },
    closeModal: function closeModal() {
      this.modalOpen = !this.modalOpen;
    },
    editClient: function editClient() {
      var _this2 = this;

      var image = document.getElementById('logo2').files[0];
      var fd = new __WEBPACK_IMPORTED_MODULE_2_form_data___default.a();
      fd.append('file', image, 'file');
      var index = this.clients.indexOf(this.onEditClient);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients/' + this.onEditClient._id, this.onEditClient).then(function (response) {
        // let index = this.clients.indexOf(item)
        _this2.clients[index] = response.data;
        _this2.modalOpen = !_this2.modalOpen;
        // console.log(response)
        if (image) {
          fd.append('clientId', true);
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + _this2.onEditClient._id + '/upload', fd, {
            headers: { 'Content-Type': undefined }
          }).then(function (response) {
            console.log(response.data);
          }).catch(function (error) {
            console.log(error);
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteClient: function deleteClient(item) {
      var _this3 = this;

      if (!window.confirm('Are you sure you want to delete the user?')) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients/' + item._id).then(function (response) {
        var index = _this3.clients.indexOf(item);
        _this3.clients.splice(index, 1);
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    addClient: function addClient() {
      var _this4 = this;

      var image = document.getElementById('logo').files[0];
      var fd = new __WEBPACK_IMPORTED_MODULE_2_form_data___default.a();
      fd.append('file', image, 'file');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/clients', {
        companyName: this.client.companyName,
        websiteURL: this.client.url,
        logoPath: this.client.logoPath,
        contactPerson: {
          firstName: this.client.firstName,
          lastName: this.client.lastName,
          email: this.client.email,
          role: this.client.userRole,
          phone: this.client.phone,
          password: this.client.password
        },
        address: {
          country: this.client.country,
          city: this.client.city,
          postalCode: this.client.code,
          street: this.client.street
        }
      }).then(function (response) {
        _this4.clients.push(response.data.client);
        if (image) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/users/' + response.data.userId + '/upload', fd, {
            headers: { 'Content-Type': undefined }
          }).then(function (response) {
            console.log(response.data);
          }).catch(function (error) {
            console.log(error);
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datetime_dist_vue_datetime_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_2_vue_datetime__["Datetime"]
  },
  data: function data() {
    return {
      datePlaceholder: 'Set time',
      error: '',
      submitOnProcess: false,
      contactInfo: {
        name: '',
        email: '',
        phoneNumber: '',
        time: '',
        details: ''
      }
    };
  },

  methods: {
    submitContactForm: function submitContactForm() {
      var _this = this;

      this.submitOnProcess = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/submitContactForm', this.contactInfo).then(function (response) {
        _this.submitOnProcess = false;
        _this.contactInfo = {
          name: '',
          email: '',
          phoneNumber: '',
          time: '',
          details: ''
        };
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalConstants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      fullPage: true,
      isLoading: true,
      message: '',
      options: [],
      pictureName: '',
      pictureName2: '',
      onEditUser: {},
      contactModalOpen: false,
      inviteModalOpen: false,
      remindModalOpen: false,
      user: {
        firstName: '',
        lastName: '',
        email: ''
      },
      currentUser: {},
      initiative: {
        id: '',
        name: '',
        deadline: '',
        teamName: '',
        initiativeDetails: '',
        members: []
      },
      sortedMembers: [],
      members: [{
        email: ''
      }],
      error: false
    };
  },
  created: function created() {
    this.loadTeam();
  },

  computed: {
    displayMembers: function displayMembers() {
      return this.sortedMembers;
    }
  },
  methods: {
    loadTeam: function loadTeam() {
      var _this = this;

      var user = JSON.parse(window.localStorage.getItem('user'));
      this.user = user;
      this.sortedMembers.length = 0;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/createdInitiatives/' + user._id).then(function (response) {
        if (response.data.length > 0) {
          _this.initiative.id = response.data[0]._id;
          _this.initiative.teamLead = response.data[0].teamLead.firstName + ' ' + response.data[0].teamLead.lastName;
          _this.initiative.name = response.data[0].initiativeName;
          _this.initiative.deadline = new Date(response.data[0].deadline).toLocaleString();
          _this.initiative.teamName = response.data[0].teamName;
          _this.initiative.members = response.data[0].members;
          // not joined, status 1
          for (var j = 0; j < _this.initiative.members.length; j++) {
            if (!_this.initiative.members[j].user.joining) {
              _this.sortedMembers.push({ 'member': _this.initiative.members[j].user.email, 'role': 'TM', 'status': 1, 'action': true, 'id': _this.initiative.members[j].user._id });
            }
          }
          for (var _j = 0; _j < _this.initiative.members.length; _j++) {
            if (_this.initiative.members[_j].user.joining && !_this.initiative.members[_j].user.diagonacticCompleted) {
              var role = 'TM';
              if (_this.initiative.members[_j].user.type === 'companyAdmin') {
                role = 'TL';
              }
              _this.sortedMembers.push({ 'member': _this.initiative.members[_j].user.firstName + ' ' + _this.initiative.members[_j].user.lastName + ' (' + _this.initiative.members[_j].user.email + ')', 'role': role, 'status': 2, 'action': true, 'id': _this.initiative.members[_j].user._id });
            }
          }
          // Assessment complete, status 3
          for (var _j2 = 0; _j2 < _this.initiative.members.length; _j2++) {
            if (_this.initiative.members[_j2].user.joining && _this.initiative.members[_j2].user.diagonacticCompleted) {
              var _role = 'TM';
              if (_this.initiative.members[_j2].user.type === 'companyAdmin') {
                _role = 'TL';
              }
              _this.sortedMembers.push({ 'member': _this.initiative.members[_j2].user.firstName + ' ' + _this.initiative.members[_j2].user.lastName + ' (' + _this.initiative.members[_j2].user.email + ')', 'role': _role, 'status': 3, 'action': false, 'id': _this.initiative.members[_j2].user._id });
            }
          }
        }
        _this.isLoading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    contactModal: function contactModal() {
      this.contactModalOpen = true;
    },
    closeContactModal: function closeContactModal() {
      this.contactModalOpen = false;
      this.message = '';
    },
    contactSubmit: function contactSubmit() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/submitContactForm', { name: this.user.firstName + ' ' + this.user.lastName, email: this.user.email, details: this.message }).then(function (response) {
        _this2.contactModalOpen = false;
        _this2.message = '';
        _this2.$noty.success('Thanks for connecting with us. We will get back to you as soon as possible.');
      }).catch(function (error) {
        console.log(error);
      });
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    addUser: function addUser() {
      var _this3 = this;

      if (!this.validateEmail(this.members[0].email)) {
        this.$noty.error('Please enter valid email address.');
        this.members[0].email = '';
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/invite', { inviter: this.user, members: this.members, initiativeID: this.initiative.id }).then(function (response) {
          _this3.loadTeam();
          // this.sortedMembers.unshift({member: this.members[0].email, role: 'TM', status: 1, action: true, id: response.data.invitedIDs[0]})
          _this3.$noty.success('Invitation email sent to join the risk assessment.');
          _this3.members[0].email = '';
        }).catch(function (error) {
          console.log('error on saving client' + error);
          _this3.$noty.error(error.response.data.message);
        });
      }
    },
    deleteUser: function deleteUser(item) {
      var _this4 = this;

      var message = 'Are you sure you want to delete the user?';
      var options = {
        loader: true,
        okText: 'Yes',
        cancelText: 'No'
      };
      this.$dialog.confirm(message, options).then(function (dialog) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/initiative/removeMember', { 'initiativeID': _this4.initiative.id, 'userID': item.id }).then(function (response) {
          _this4.loadTeam();
          _this4.$noty.success('User removed successfully.');
          dialog.close();
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },
    remind: function remind(item) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__globalConstants_js__["a" /* apiURL */] + '/api/v1/remind', { inviter: this.user, 'initiativeID': this.initiative.id, 'userID': item.id }).then(function (response) {
        _this5.$noty.success('Reminder sent successfully.');
      }).catch(function (error) {
        console.log(error);
      });
    },
    inviteModal: function inviteModal() {
      this.inviteModalOpen = true;
    },
    closeInviteModal: function closeInviteModal() {
      this.inviteModalOpen = false;
    },
    remindModal: function remindModal() {
      this.remindModalOpen = true;
    },
    closeRemindModal: function closeRemindModal() {
      this.remindModalOpen = false;
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'OfcoldSecurityCode',
	props: {
		value: {
			type: [Number, String],
			required: true
		},
		blurOnComplete: {
			type: Boolean,
			default: false
		},
		securityCodeLength: {
			type: Number,
			default: 6
		},
		isArray: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			securityCode: new Array(this.securityCodeLength)
		};
	},
	mounted: function mounted() {
		if (this.value !== 0) {
			this.securityCode = this.value.toString().substr(0, this.securityCodeLength).split('');
		}
	},

	methods: {
		inputEvent: function inputEvent(event) {
			var value = event.target.value;

			if (value.length > 1) {
				event.target.value = value.substr(0, 1);
			}

			this.getCodeString().length === this.securityCodeLength ? this.blurOnComplete ? event.target.blur() : this.nextElement(event) : event.target.value && this.nextElement(event);
		},

		/**
   * Listen paste event.
   *
   * @param  {[type]} index
   * @param  {[type]} event
   *
   * @return {[array]}
   */
		pasteEvent: function pasteEvent(index, event) {
			var i = void 0,
			    pasteData = void 0,
			    elements = event.target.parentNode.parentNode.childNodes,
			    len = 0,
			    vm = this;

			for (event.clipboardData && event.clipboardData.getData ? pasteData = event.clipboardData.getData('Text') : window.clipboardData && window.clipboardData.getData && (pasteData = window.clipboardData.getData('Text')), pasteData = pasteData.replace(/\s/g, '').substr(0, elements.length - index).split(''), i = 0; i < elements.length && !isNaN(Number(pasteData[i])); i++) {
				len++;
				elements[i + index].firstChild.value = pasteData[i];
				vm.securityCode[i + index] = pasteData[i];
			}

			return [setTimeout(function () {
				vm.getCodeString().length === vm.securityCodeLength ? vm.blurOnComplete ? event.target.blur() : vm.previousElement(event, vm.getCodeString().length - 1) : vm.previousElement(event, index + len);
			}, 0), event.preventDefault(), false];
		},
		pressEvent: function pressEvent(event) {
			var keyCode = event.which || event.keyCode;
			return this.isMainKeyCode(keyCode) || this.isTab(keyCode) || this.isBackspace(keyCode) || this.isMetaKey(event, keyCode) ? void 0 : (event.preventDefault(), false);
		},
		downEvent: function downEvent(event) {
			var parentNode = event.target.parentNode;
			var keyCode = event.which || event.keyCode;
			var _sibling = void 0;

			if (keyCode === 8 && !event.target.value) {
				_sibling = parentNode.previousSibling;
				if (_sibling) {
					_sibling.firstChild.focus();
				}
			} else if (keyCode >= 37 && keyCode <= 41) {
				switch (keyCode) {
					case 37:
						_sibling = parentNode.previousSibling;
						break;
					case 39:
						_sibling = parentNode.nextSibling;
						break;
				}
				if (_sibling) {
					_sibling.firstChild.focus();
				}
				return [event.preventDefault(), false];
			}
		},
		previousElement: function previousElement(event, length) {
			var elements = event.target.parentNode.parentNode.childNodes;

			if (length >= elements.length) {
				length = elements.length - 1;
			}

			elements[length].firstChild.focus();
		},
		nextElement: function nextElement(event) {
			var parentNode = event.target.parentNode;
			var nextSibling = parentNode.nextSibling;

			nextSibling ? nextSibling.firstChild.focus() : parentNode.focus();
		},
		isMainKeyCode: function isMainKeyCode(keyCode) {
			return keyCode >= 48 && keyCode <= 57;
		},
		isTab: function isTab(keyCode) {
			return keyCode === 9;
		},
		isBackspace: function isBackspace(keyCode) {
			return keyCode === 8;
		},
		isMetaKey: function isMetaKey(event, keyCode) {
			return event.metaKey && keyCode === 118;
		},
		setSelected: function setSelected(event) {
			event.target.select();
		},
		getCodeString: function getCodeString() {
			var code = this.isArray ? this.securityCode : this.securityCode.join('');
			this.$emit('input', code);

			return code;
		}
	}
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//

 // With moment.js

var types = ['line', 'bar', 'radar', 'polarArea', 'pie', 'doughnut', 'bubble', 'scatter'];

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    width: Number,
    height: Number,
    type: {
      type: String,
      required: true,
      validator: function validator(val) {
        return types.includes(val);
      }
    },
    data: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    plugins: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.resetChart();
  },
  data: function data() {
    return {
      chart: null
    };
  },


  methods: {
    resetChart: function resetChart() {
      if (this.chart) this.chart.destroy();

      this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$el, {
        type: this.type,
        data: this.data,
        options: this.options,
        plugins: this.plugins
      });
    }
  },

  watch: {
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        return _this.resetChart();
      });
    },
    data: function data() {
      this.chart.update();
    },
    options: function options() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.resetChart();
      });
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.01
    },
    value: {
      type: Number,
      default: 0
    },
    type: String,
    name: String,
    size: String,
    isFullwidth: Boolean,
    disabled: Boolean,
    // orientation:
    vertical: Boolean
  },

  data: function data() {
    return {
      realValue: this.value
    };
  },
  beforeMount: function beforeMount() {
    if (this.max < this.min) {
      throw 'Unexpected range setting: Maximum cannot be less than minimum';
    }

    this.update(this.value);
  },
  mounted: function mounted() {
    this.$el.style.setProperty('--low', this.low);
    this.$el.style.setProperty('--high', this.high);
  },


  watch: {
    realValue: function realValue(newVal, oldVal) {
      if (Number(newVal) !== Number(oldVal)) {
        this.$el.style.setProperty('--high', this.high);
        this.$emit('change', newVal);
      }
    },
    value: function value(val) {
      this.update(val);
    }
  },

  methods: {
    update: function update(val) {
      if (val > this.max) {
        this.realValue = this.max;
      } else if (val < this.min) {
        this.realValue = this.min;
      } else {
        this.realValue = val;
      }
    }
  },

  computed: {
    low: function low() {
      return '0%';
    },
    high: function high() {
      return (this.realValue - this.min) / (this.max - this.min) * 100 + '%';
    },
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          isFullwidth = this.isFullwidth;

      return _ref = {
        slider: true
      }, _defineProperty(_ref, 'is-' + type, type), _defineProperty(_ref, 'is-' + size, size), _defineProperty(_ref, 'is-fullwidth', isFullwidth), _ref;
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alignment: {
      type: String,
      default: ''
    }
  },

  computed: {
    classObject: function classObject() {
      var alignment = this.alignment;

      return _defineProperty({
        'tab-list': true,
        'is-flex': true
      }, 'is-' + alignment, alignment);
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TS = {
  'fade': {
    enterClass: 'fadeIn',
    leaveClass: 'fadeOut'
  },
  'fade-horizontal-rtl': {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutLeft'
  },
  'fade-horizontal-ltr': {
    enterClass: 'fadeInLeft',
    leaveClass: 'fadeOutRight'
  },
  'slide-horizontal-rtl': {
    enterClass: 'slideInRight',
    leaveClass: 'slideOutLeft'
  },
  'slide-horizontal-ltr': {
    enterClass: 'slideInLeft',
    leaveClass: 'slideOutRight'
  },
  'fade-vertical-dtu': {
    enterClass: 'fadeInUp',
    leaveClass: 'fadeOutUp'
  },
  'fade-vertical-utd': {
    enterClass: 'fadeInDown',
    leaveClass: 'fadeOutDown'
  },
  'slide-vertical-dtu': {
    enterClass: 'slideInUp',
    leaveClass: 'slideOutUp'
  },
  'slide-vertical-utd': {
    enterClass: 'slideInDown',
    leaveClass: 'slideOutDown'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    selected: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'out-in'
    }
  },

  data: function data() {
    return {
      realSelected: this.selected,
      transition: TS['fade']
    };
  },
  created: function created() {
    this.$parent.tabPanes.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.tabPanes.splice(this.index, 1);
  },


  computed: {
    classObject: function classObject() {
      var realSelected = this.realSelected;

      return {
        'tab-pane': true,
        'animated': true,
        'is-active': realSelected,
        'is-deactive': !realSelected
      };
    },
    layout: function layout() {
      return this.$parent.layout;
    },
    direction: function direction() {
      if (this.layout === 'top' || this.layout === 'bottom') {
        return 'horizontal';
      } else if (this.layout === 'left' || this.layout === 'right') {
        return 'vertical';
      }
      return '';
    },
    animation: function animation() {
      return this.$parent.animation;
    },
    onlyFade: function onlyFade() {
      return this.$parent.onlyFade;
    },
    gte: function gte() {
      if (this.direction === 'vertical') {
        return 'utd';
      } else if (this.direction === 'horizontal') {
        return 'ltr';
      }
      return '';
    },
    lt: function lt() {
      if (this.direction === 'vertical') {
        return 'dtu';
      } else if (this.direction === 'horizontal') {
        return 'rtl';
      }
      return '';
    },
    hidden: function hidden() {
      return this.realSelected ? 'false' : 'true';
    },
    index: function index() {
      return this.$parent.tabPanes.indexOf(this);
    }
  },

  watch: {
    '$parent.realSelectedIndex': function $parentRealSelectedIndex(index, prevIndex) {
      if (!this.onlyFade) {
        var transition = void 0;
        if (prevIndex === -1 || prevIndex > index) {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.gte ? '-' + this.gte : '');
        } else {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.lt ? '-' + this.lt : '');
        }
        this.transition = TS[transition] || TS['fade'];
      }
      this.realSelected = this.index === index;
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TabList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client_globalConstants_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TabList: __WEBPACK_IMPORTED_MODULE_0__TabList___default.a
  },

  props: {
    isFullwidth: Boolean,
    layout: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'bottom', 'left', 'right'].indexOf(val) > -1;
      }
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    alignment: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    animation: {
      type: String,
      default: 'fade'
    },
    onlyFade: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      realSelectedIndex: this.selectedIndex,
      tabPanes: []
    };
  },
  mounted: function mounted() {
    this.update();
    if (this.realSelectedIndex === -1) {
      this.select(0);
    }
    __WEBPACK_IMPORTED_MODULE_1__client_globalConstants_js__["b" /* EventBus */].$on('bulmaTabs', function (selectedTab) {
      console.log(selectedTab);
      this.selectedIndex = 3;
    });
  },

  methods: {
    update: function update() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.tabPanes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tabPane = _step.value;

          if (!tabPane.disabled && tabPane.realSelected) {
            this.select(tabPane.index);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isActived: function isActived(index) {
      return index === this.realSelectedIndex;
    },
    select: function select(index) {
      __WEBPACK_IMPORTED_MODULE_1__client_globalConstants_js__["b" /* EventBus */].$emit('tab-selected', { 'id': this.$el, 'index': index });
      this.realSelectedIndex = index;
    }
  },
  watch: {
    selectedIndex: function selectedIndex(newIndex) {
      this.select(newIndex);
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */,
/* 328 */,
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 31,
	"./af.js": 31,
	"./ar": 38,
	"./ar-dz": 32,
	"./ar-dz.js": 32,
	"./ar-kw": 33,
	"./ar-kw.js": 33,
	"./ar-ly": 34,
	"./ar-ly.js": 34,
	"./ar-ma": 35,
	"./ar-ma.js": 35,
	"./ar-sa": 36,
	"./ar-sa.js": 36,
	"./ar-tn": 37,
	"./ar-tn.js": 37,
	"./ar.js": 38,
	"./az": 39,
	"./az.js": 39,
	"./be": 40,
	"./be.js": 40,
	"./bg": 41,
	"./bg.js": 41,
	"./bm": 42,
	"./bm.js": 42,
	"./bn": 43,
	"./bn.js": 43,
	"./bo": 44,
	"./bo.js": 44,
	"./br": 45,
	"./br.js": 45,
	"./bs": 46,
	"./bs.js": 46,
	"./ca": 47,
	"./ca.js": 47,
	"./cs": 48,
	"./cs.js": 48,
	"./cv": 49,
	"./cv.js": 49,
	"./cy": 50,
	"./cy.js": 50,
	"./da": 51,
	"./da.js": 51,
	"./de": 54,
	"./de-at": 52,
	"./de-at.js": 52,
	"./de-ch": 53,
	"./de-ch.js": 53,
	"./de.js": 54,
	"./dv": 55,
	"./dv.js": 55,
	"./el": 56,
	"./el.js": 56,
	"./en-SG": 57,
	"./en-SG.js": 57,
	"./en-au": 58,
	"./en-au.js": 58,
	"./en-ca": 59,
	"./en-ca.js": 59,
	"./en-gb": 60,
	"./en-gb.js": 60,
	"./en-ie": 61,
	"./en-ie.js": 61,
	"./en-il": 62,
	"./en-il.js": 62,
	"./en-nz": 63,
	"./en-nz.js": 63,
	"./eo": 64,
	"./eo.js": 64,
	"./es": 67,
	"./es-do": 65,
	"./es-do.js": 65,
	"./es-us": 66,
	"./es-us.js": 66,
	"./es.js": 67,
	"./et": 68,
	"./et.js": 68,
	"./eu": 69,
	"./eu.js": 69,
	"./fa": 70,
	"./fa.js": 70,
	"./fi": 71,
	"./fi.js": 71,
	"./fo": 72,
	"./fo.js": 72,
	"./fr": 75,
	"./fr-ca": 73,
	"./fr-ca.js": 73,
	"./fr-ch": 74,
	"./fr-ch.js": 74,
	"./fr.js": 75,
	"./fy": 76,
	"./fy.js": 76,
	"./ga": 77,
	"./ga.js": 77,
	"./gd": 78,
	"./gd.js": 78,
	"./gl": 79,
	"./gl.js": 79,
	"./gom-latn": 80,
	"./gom-latn.js": 80,
	"./gu": 81,
	"./gu.js": 81,
	"./he": 82,
	"./he.js": 82,
	"./hi": 83,
	"./hi.js": 83,
	"./hr": 84,
	"./hr.js": 84,
	"./hu": 85,
	"./hu.js": 85,
	"./hy-am": 86,
	"./hy-am.js": 86,
	"./id": 87,
	"./id.js": 87,
	"./is": 88,
	"./is.js": 88,
	"./it": 90,
	"./it-ch": 89,
	"./it-ch.js": 89,
	"./it.js": 90,
	"./ja": 91,
	"./ja.js": 91,
	"./jv": 92,
	"./jv.js": 92,
	"./ka": 93,
	"./ka.js": 93,
	"./kk": 94,
	"./kk.js": 94,
	"./km": 95,
	"./km.js": 95,
	"./kn": 96,
	"./kn.js": 96,
	"./ko": 97,
	"./ko.js": 97,
	"./ku": 98,
	"./ku.js": 98,
	"./ky": 99,
	"./ky.js": 99,
	"./lb": 100,
	"./lb.js": 100,
	"./lo": 101,
	"./lo.js": 101,
	"./lt": 102,
	"./lt.js": 102,
	"./lv": 103,
	"./lv.js": 103,
	"./me": 104,
	"./me.js": 104,
	"./mi": 105,
	"./mi.js": 105,
	"./mk": 106,
	"./mk.js": 106,
	"./ml": 107,
	"./ml.js": 107,
	"./mn": 108,
	"./mn.js": 108,
	"./mr": 109,
	"./mr.js": 109,
	"./ms": 111,
	"./ms-my": 110,
	"./ms-my.js": 110,
	"./ms.js": 111,
	"./mt": 112,
	"./mt.js": 112,
	"./my": 113,
	"./my.js": 113,
	"./nb": 114,
	"./nb.js": 114,
	"./ne": 115,
	"./ne.js": 115,
	"./nl": 117,
	"./nl-be": 116,
	"./nl-be.js": 116,
	"./nl.js": 117,
	"./nn": 118,
	"./nn.js": 118,
	"./pa-in": 119,
	"./pa-in.js": 119,
	"./pl": 120,
	"./pl.js": 120,
	"./pt": 122,
	"./pt-br": 121,
	"./pt-br.js": 121,
	"./pt.js": 122,
	"./ro": 123,
	"./ro.js": 123,
	"./ru": 124,
	"./ru.js": 124,
	"./sd": 125,
	"./sd.js": 125,
	"./se": 126,
	"./se.js": 126,
	"./si": 127,
	"./si.js": 127,
	"./sk": 128,
	"./sk.js": 128,
	"./sl": 129,
	"./sl.js": 129,
	"./sq": 130,
	"./sq.js": 130,
	"./sr": 132,
	"./sr-cyrl": 131,
	"./sr-cyrl.js": 131,
	"./sr.js": 132,
	"./ss": 133,
	"./ss.js": 133,
	"./sv": 134,
	"./sv.js": 134,
	"./sw": 135,
	"./sw.js": 135,
	"./ta": 136,
	"./ta.js": 136,
	"./te": 137,
	"./te.js": 137,
	"./tet": 138,
	"./tet.js": 138,
	"./tg": 139,
	"./tg.js": 139,
	"./th": 140,
	"./th.js": 140,
	"./tl-ph": 141,
	"./tl-ph.js": 141,
	"./tlh": 142,
	"./tlh.js": 142,
	"./tr": 143,
	"./tr.js": 143,
	"./tzl": 144,
	"./tzl.js": 144,
	"./tzm": 146,
	"./tzm-latn": 145,
	"./tzm-latn.js": 145,
	"./tzm.js": 146,
	"./ug-cn": 147,
	"./ug-cn.js": 147,
	"./uk": 148,
	"./uk.js": 148,
	"./ur": 149,
	"./ur.js": 149,
	"./uz": 151,
	"./uz-latn": 150,
	"./uz-latn.js": 150,
	"./uz.js": 151,
	"./vi": 152,
	"./vi.js": 152,
	"./x-pseudo": 153,
	"./x-pseudo.js": 153,
	"./yo": 154,
	"./yo.js": 154,
	"./zh-cn": 155,
	"./zh-cn.js": 155,
	"./zh-hk": 156,
	"./zh-hk.js": 156,
	"./zh-tw": 157,
	"./zh-tw.js": 157
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 329;

/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/headerLogo.bf086ce.png";

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)
__webpack_require__(319)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(305)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(364),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(308)
__webpack_require__(309)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(370),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(300)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  "data-v-177f9cba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  "data-v-a50344fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(298)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  "data-v-0feaa46a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(366),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(378),
  /* scopeId */
  "data-v-739c4327",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(302)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(367),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(303)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    attrs: {
      "src": "https://www.changevu.com/ChangeVU-ChangeRiskMtgAgenda.pdf",
      "frameborder": "0"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "diagnostic"
    }
  }, [(_vm.isSubmitted) ? _c('div', {
    staticClass: "pendingLayer"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-fullhd",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "content progress-result has-text-right"
  }, [_c('strong', {
    staticClass: "has-text-primary"
  }, [_vm._v(_vm._s(_vm.currentStep))]), _vm._v(" out of "), _c('strong', {
    staticClass: "has-text-primary"
  }, [_vm._v(_vm._s(_vm.totalSteps))]), _vm._v(" "), _c('progress', {
    staticClass: "progress is-primary",
    attrs: {
      "max": _vm.totalSteps
    },
    domProps: {
      "value": _vm.currentStep
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.step === 1) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[0].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.identifySponsor),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update1
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.identifySponsor),
      expression: "identifySponsor"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.identifySponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.identifySponsor = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(3)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[1].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.visionClarity),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update2
    }
  }), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visionClarity),
      expression: "visionClarity"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.visionClarity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visionClarity = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(6)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[2].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.sponsoringCoalition),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update3
    }
  }), _vm._v(" "), _vm._m(8)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsoringCoalition),
      expression: "sponsoringCoalition"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.sponsoringCoalition)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsoringCoalition = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(9)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[3].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.sponsorCapability),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update4
    }
  }), _vm._v(" "), _vm._m(11)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsorCapability),
      expression: "sponsorCapability"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.sponsorCapability)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsorCapability = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(12)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[4].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.governance),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update5
    }
  }), _vm._v(" "), _vm._m(14)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.governance),
      expression: "governance"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.governance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.governance = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(15)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                 " + _vm._s(_vm.risks[5].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.programmeManagement),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update6
    }
  }), _vm._v(" "), _vm._m(17)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.programmeManagement),
      expression: "programmeManagement"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.programmeManagement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.programmeManagement = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(18)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 7) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[6].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.budgetingandResourcing),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update7
    }
  }), _vm._v(" "), _vm._m(20)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetingandResourcing),
      expression: "budgetingandResourcing"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.budgetingandResourcing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.budgetingandResourcing = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(21)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 8) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[7].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.programmeDelivery),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update8
    }
  }), _vm._v(" "), _vm._m(23)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.programmeDelivery),
      expression: "programmeDelivery"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.programmeDelivery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.programmeDelivery = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(24)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 9) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[8].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.businessRequirements),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update9
    }
  }), _vm._v(" "), _vm._m(26)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.businessRequirements),
      expression: "businessRequirements"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.businessRequirements)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.businessRequirements = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(27)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 10) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[9].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.organizationDesign),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update10
    }
  }), _vm._v(" "), _vm._m(29)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationDesign),
      expression: "organizationDesign"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.organizationDesign)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationDesign = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(30)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 11) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[10].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.changeReadiness),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update11
    }
  }), _vm._v(" "), _vm._m(32)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeReadiness),
      expression: "changeReadiness"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.changeReadiness)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeReadiness = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(33)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 12) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[11].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.implementationPlanning),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update12
    }
  }), _vm._v(" "), _vm._m(35)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.implementationPlanning),
      expression: "implementationPlanning"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.implementationPlanning)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.implementationPlanning = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(36)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 13) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                 " + _vm._s(_vm.risks[12].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.changeLeadership),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update13
    }
  }), _vm._v(" "), _vm._m(38)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeLeadership),
      expression: "changeLeadership"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.changeLeadership)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeLeadership = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(39)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 14) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[13].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.stakeholderEngagement),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update14
    }
  }), _vm._v(" "), _vm._m(41)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stakeholderEngagement),
      expression: "stakeholderEngagement"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.stakeholderEngagement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stakeholderEngagement = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(42)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 15) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[14].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.implementationCapability),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update15
    }
  }), _vm._v(" "), _vm._m(44)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.implementationCapability),
      expression: "implementationCapability"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.implementationCapability)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.implementationCapability = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(45)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 16) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[15].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.supportPeoplesJournery),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update16
    }
  }), _vm._v(" "), _vm._m(47)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportPeoplesJournery),
      expression: "supportPeoplesJournery"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.supportPeoplesJournery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supportPeoplesJournery = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(48)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-mobile"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal successModal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n            Thank you!\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n          Your submission has been received! When all participants have submitted their scores, you can access the team scores.\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_vm._v("\n          Thank you for using ChangeVU!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-white has-text-weight-bold"
  }, [_vm._v("\n        Your submission has been received! When all participants have submitted their scores, you will receive a message to access the team scores.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
}]}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tos"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "Default",
    staticStyle: {
      "text-align": "center",
      "tab-stops": "191.4pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("STRATICOM TECHNOLOGIES, INC. TERMS OF USE\n\t\t\t(“Agreement”)"), _c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "Default",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("BY CLICKING “AGREE”\n\t\t\tBELOW YOU ACKNOWLEDGE YOU (“CLIENT”) WILL COMPLY WITH THE LEGAL CONDITIONS SET\n\t\t\tFORTH BELOW REGARDING CLIENT’S USE OF THE LICENSED SOFTWARE (as that term is\n\t\t\tdefined below) PROVIDED BY STRATICOM TECHNOLOGIES R&D INC. (“ST”). "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Grant of License "), _c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("“Licensed Software”\n\t\t\tmeans certain demo/trial version of ChangeVU"), _c('sup', [_vm._v("TM")]), _vm._v(" software and\n\t\t\tresulting outputs and all related documentation, notes, instructions, and\n\t\t\trelated writings used in conjunction with the Licensed Software provided to\n\t\t\tClient by Straticom Technologies, Inc. In consideration of goodwill and market exposure\n\t\t\tearned by ST by providing demo/trial versions of the Licensed Software to\n\t\t\tassist Client’s evaluation of the Licensed Software, ST hereby grants to Client\n\t\t\ta limited, non-transferable, and non-exclusive license to use the Licensed\n\t\t\tSoftware for purposes of evaluation. This grant of license does not transfer or\n\t\t\tassign, in any manner, title of the Licensed Software to Client or any other\n\t\t\tparty. ST retains title and ownership of the Licensed Software, releases, trade\n\t\t\tsecrets, and any derivatives. The Licensed Software is copyrighted, licensed,\n\t\t\tand owned exclusively by ST. Under this license, Client may not modify, adapt,\n\t\t\ttranslate, reverse engineer, de-compile, or disassemble the Licensed Software,\n\t\t\tor create derivatives based on the Licensed Software or the accompanying\n\t\t\twritten materials. Client may not transfer, assign, give, sell, rent, lease,\n\t\t\tdistribute, or otherwise dispose of any Licensed Software. Client acknowledges\n\t\t\tthat violation of this Agreement may result in a suit for damages, injunctive\n\t\t\trelief, legal fees, and any other remedies available to ST in law or in equity.\n\t\t\t"), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(0), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": Client understands\n\t\t\tand expressly agrees that Client are responsible for determining the\n\t\t\tappropriateness for any given use by Client of the Licensed Software and Client\n\t\t\tassumes the risk for any such use. Client understands and expressly agrees that\n\t\t\tST and its products and services (i) are not in any way a substitute for the\n\t\t\tadvice of a lawyer and (ii) do not constitute legal advice, counsel, or\n\t\t\tbusiness advice of any sort, in any jurisdiction, on any matter. ST may make\n\t\t\tadditional releases of the Licensed Software that ST, in its sole discretion,\n\t\t\tdeems necessary. Client acknowledges that ST is under no continuing obligation\n\t\t\tto provide access to the Licensed Software and ST may terminate this Agreement\n\t\t\tat any time. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(1), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": No rights or\n\t\t\tlicenses, expressed or implied, are hereby granted to Client under any patents,\n\t\t\tcopyrights, or trade secrets of ST as a result of or related to this Agreement.\n\t\t\tClient agrees that the Licensed Software is proprietary to ST. In the event of\n\t\t\tan actual or threatened breach any provision of this Agreement, ST will be\n\t\t\tentitled to an injunction restraining Client from such breach and this will be\n\t\t\tin addition to any other rights or remedies that ST may have in law or in\n\t\t\tequity. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Client acknowledges\n\t\t\tthat the Licensed Software and each of its component parts are the valuable\n\t\t\ttrade secrets of ST and that the component parts and outputs are subject to\n\t\t\tcopyright laws. The use of a copyright notice will not be taken to indicate\n\t\t\tthat the Licensed Software or any of its component parts or output has been\n\t\t\tpublished. Client may not remove any copyright, trademark, or other\n\t\t\tintellectual property rights notices from the Licensed Software, including from\n\t\t\tany outputs generated by the Licensed Software. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Client warrants that\n\t\t\tall employees, agents, and representatives having access to the Licensed\n\t\t\tSoftware under this Agreement will do so with Client’s authorization and will\n\t\t\tcomply with the terms regarding the Licensed Software. Client assumes\n\t\t\tresponsibility for compliance by such employees, agents, and representatives\n\t\t\twith the confidentiality and proprietary protection provisions of this\n\t\t\tAgreement. Client will be responsible for any breach of this Agreement by\n\t\t\tClient’s employees, agents, and representatives who access to the Licensed\n\t\t\tSoftware. Client may not utilize the Licensed Software to perform service\n\t\t\tbureau work, time sharing, or process data for any third-party without the\n\t\t\tprior express written consent of the CEO of ST. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Client warrants that\n\t\t\tit will not seek to discover or to disclose any of ST’s trade secrets by\n\t\t\tdisassembling, decompiling, or otherwise reverse engineering the Licensed\n\t\t\tSoftware or any parts or outputs thereof. Client agrees to take all reasonable\n\t\t\tsteps to protect the Licensed Software and all documentation from theft or from\n\t\t\tuse by others contrary to the terms of this Agreement. Client agrees to\n\t\t\tpromptly notify ST in writing of any unauthorized use, infringement, misappropriation,\n\t\t\tdilution, or other violation of the Licensed Software of which Client becomes\n\t\t\taware. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(2), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": ST IS NOT\n\t\t\tLIABLE FOR ANY (i) LOST PROFITS, (ii) INDIRECT, INCIDENTAL, MULTIPLE,\n\t\t\tEXEMPLARY, PUNITIVE, CONSEQUENTIAL, OR ANY OTHER SPECIAL DAMAGES, INCLUDING BUT\n\t\t\tNOT LIMITED TO ANY LOSS OF DATA, PROSPECTIVE PROFITS ON ANTICIPATED SALES, OR\n\t\t\tON ACCOUNT OF EXPENDITURES, INVESTMENTS, LEASES, OR OTHER COMMITMENTS RELATING\n\t\t\tTO THE BUSINESS OR GOODWILL OF EITHER PARTY; OR (iii) ANY CLAIMS BROUGHT\n\t\t\tAGAINST CLIENT REGARDLESS OF WHETHER OR NOT ST HAD NOTICE OF SUCH CLAIMS. THIS\n\t\t\tLIMITATION OF DAMAGES WILL APPLY WITHOUT REGARD TO OTHER PROVISIONS OF THIS\n\t\t\tAGREEMENT. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("ST MAKES NO\n\t\t\tWARRANTIES WITH RESPECT TO THE LICENSED SOFTWARE AND ST DISCLAIMS ALL WARRANTIES,\n\t\t\tEITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTY OF\n\t\t\tMERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. ST IS NOT RESPONSIBLE FOR\n\t\t\tAND MAKES NO REPRESENTATIONS OR WARRANTIES WITH REGARD TO THIRD-PARTY OPERATING\n\t\t\tSYSTEMS, COMPUTER HARDWARE, SOFTWARE, OR PERIPHERALS THAT CLIENT USES IN\n\t\t\tCONJUNCTION WITH THE LICENSED SOFTWARE. THE USE OF THE LICENSED SOFTWARE IS\n\t\t\t“AS-IS” AND WITH ALL FAULTS AND DEFECTS. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(3), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": Client hereby agrees to indemnify and\n\t\t\thold harmless ST from and against all claims, liability, loss, damages, or\n\t\t\texpenses, including reasonable attorneys' fees, by reason of any claim against ST\n\t\t\tbrought by any third party in regard to Client’s use of the Licensed Software. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(5), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": This Agreement\n\t\t\twill be construed according to the laws of the Province of Ontario and the\n\t\t\tfederal laws of Canada applicable thereto, without regard to conflict of laws\n\t\t\trules. Client and ST agree that for all disputes, claims, and controversies\n\t\t\tbetween them, whether individual, joint, or class in nature, arising from this\n\t\t\tAgreement or otherwise, including without limitation contract and tort\n\t\t\tdisputes, venue will be in Toronto, Ontario. If any action is brought related\n\t\t\tto this Agreement, ST will be entitled to recover, in addition to any other\n\t\t\taward granted, reasonable legal fees and expenses of litigation. Further,\n\t\t\trecognizing the unusual nature of software and trade secrets, Client\n\t\t\tacknowledges ST’s right to immediate injunctive relief in case of any breach of\n\t\t\tthis Agreement by Client, in addition to any other remedy in damages or in\n\t\t\tequity. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(6), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": In the event\n\t\t\tthat any one or more of the provisions, or parts of any provisions, contained\n\t\t\tin this Agreement will for any reason be held to be invalid, illegal, or\n\t\t\tunenforceable in any respect by a court of competent jurisdiction; (i) the same\n\t\t\twill not invalidate or otherwise affect any other provision hereof; (ii) this\n\t\t\tAgreement will be construed as if such invalid, illegal, or unenforceable\n\t\t\tprovision had never been contained herein; and (iii) any such invalid, illegal,\n\t\t\tor unenforceable provision will be modified so as to render it enforceable in a\n\t\t\tmanner most similar to and consistent with the original intent of this\n\t\t\tAgreement. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("The failure of ST to\n\t\t\tenforce any rights granted hereunder or to take action against Client in the\n\t\t\tevent of any breach hereunder will not be deemed a waiver by ST as to\n\t\t\tsubsequent enforcement of rights or subsequent actions in the event of future\n\t\t\tbreaches. The expiration or termination of this Agreement will not affect the\n\t\t\tprovisions of this Agreement, which by their terms and meaning are of a\n\t\t\tcontinuing nature. Client is responsible for determination and payment of the\n\t\t\tapplicable taxes and similar charges, including but not limited to sales, use,\n\t\t\tand personal property taxes assessed against it as a result of its licensing,\n\t\t\tuse, or possession of the Licensed Software. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("This Agreement\n\t\t\tconstitutes the entire agreement between ST and Client and supersedes and\n\t\t\tcancels any and all prior or contemporaneous proposals or agreements, written\n\t\t\tor oral, between ST and Client as to specific the subject matter hereof and the\n\t\t\tspecific Licensed Software specified herein and merges all prior advertising,\n\t\t\tdiscussions, proposals, purchase orders, agreements, presentations, communications\n\t\t\tand representations between them, whether written or oral. None of the parties\n\t\t\twill be bound by any conditions, definitions, warranties or representations\n\t\t\twith respect to any of the terms or conditions hereof other than as expressly\n\t\t\tprovided in this Agreement. This Agreement may only be modified by a written\n\t\t\tmodification signed by ST and Client. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("CLIENT AGREES THAT HE/SHE\n\t\t\tHAS MADE HIS/HER OWN DETERMINATION OF THE SUITABILITY OF THE LICENSED SOFTWARE\n\t\t\tFOR ITS INTENDED USE AND BUSINESS PURPOSES AND AGREES THE LICENSED SOFTWARE IS\n\t\t\tPROVIDED FOR USE ‘AS-IS’, WITH ALL FAULTS AND DEFECTS, AND WITH NO WARRANTY OF\n\t\t\tANY KIND. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_vm._m(7), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal has-text-grey"
  }, [_vm._m(8), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_c('o:p')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Assumption of\n\t\t\tRisk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Proprietary\n\t\t\tProtection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Limitation of\n\t\t\tLiability")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Indemnification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "Default"
  }, [_c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Audit Rights and\n\t\t\tNon-Public Personal Information")])]), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": ST will have the right to conduct, or direct, during normal business\n\t\t\thours a review of Client’s relevant records to verify Client’s compliance with\n\t\t\tthe terms of this Agreement. This provision does not limit ST’s right to\n\t\t\tinvestigate any conduct it believes may be a breach of the licensing terms or\n\t\t\tmay be otherwise threatening to the integrity of ST or its products or\n\t\t\tservices. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Applicable Law\n\t\t\tand Venue")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Miscellaneous\n\t\t\tProvisions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%",
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_vm._v("TO AGREE TO THESE TERMS, CLICK\n\t\t\t\"AGREE.\" IF YOU DO NOT AGREE TO THESE TERMS, DO NOT CLICK\n\t\t\t\"AGREE.\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%",
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_vm._v("Copyright 2020 Straticom Technologies R&D Inc.")])])
}]}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ofcold__security-code clearfix"
  }, [_c('div', {
    staticClass: "ofcold__security-code-wrapper"
  }, _vm._l((_vm.securityCodeLength), function(n) {
    return _c('div', {
      staticClass: "ofcold__security-code-field"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.securityCode[n - 1]),
        expression: "securityCode[n-1]"
      }],
      staticClass: "form-control",
      attrs: {
        "maxlength": "1",
        "autocorrect": "off",
        "autocomplete": "off",
        "autocapitalize": "off",
        "spellcheck": "false",
        "type": "tel"
      },
      domProps: {
        "value": (_vm.securityCode[n - 1])
      },
      on: {
        "focus": _vm.setSelected,
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.securityCode, n - 1, $event.target.value)
        }, function($event) {
          $event.stopPropagation();
          return _vm.inputEvent($event)
        }],
        "keydown": function($event) {
          $event.stopPropagation();
          return _vm.downEvent($event)
        },
        "keypress": function($event) {
          $event.stopPropagation();
          return _vm.pressEvent($event)
        },
        "paste": function($event) {
          return _vm.pasteEvent(n - 1, $event)
        }
      }
    })])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    staticClass: "chartjs",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }]
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 1rem 1rem",
      "border": "1px solid whitesmoke",
      "border-radius": "10px"
    }
  }, [_c('form', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Organization name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.companyName),
      expression: "client.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.client.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "companyName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Organization logo")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "logo",
      "id": "logo"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange()
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff",
      "max-width": "6em !important"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.pictureName ? _vm.pictureName : 'Client Logo') + "\n                    ")])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Minimum size: width 200px * height 40px")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Team name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.teamName),
      expression: "initiative.teamName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.initiative.teamName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "teamName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider",
    staticStyle: {
      "background-color": "lightgrey"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Initiative name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.name),
      expression: "initiative.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.initiative.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Assessment due date")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon deadlineInput"
  }, [_c('datetime', {
    attrs: {
      "min-datetime": new Date().toISOString(),
      "max-datetime": new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString(),
      "use12-hour": true,
      "type": "datetime",
      "minute-step": 15,
      "auto": true,
      "format": {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      },
      "placeholder": _vm.initiative.deadline
    },
    model: {
      value: (_vm.initiative.deadline),
      callback: function($$v) {
        _vm.$set(_vm.initiative, "deadline", $$v)
      },
      expression: "initiative.deadline"
    }
  }), _vm._v(" "), _vm._m(3)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Initiative description")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.initiativeDetails),
      expression: "initiative.initiativeDetails"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "3",
      "placeholder": "Enter initiative description"
    },
    domProps: {
      "value": (_vm.initiative.initiativeDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "initiativeDetails", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadData()
      }
    }
  }, [_vm._v("Reset")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n        Manage Assessment\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n        Welcome to the Assessment management page. Here you can add or modify Assessment information.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                        upload logo\n                      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
}]}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realValue),
      expression: "realValue"
    }],
    class: _vm.classObject,
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "name": _vm.name,
      "orient": _vm.vertical && 'vertical',
      "disabled": _vm.disabled,
      "number": ""
    },
    domProps: {
      "value": (_vm.realValue)
    },
    on: {
      "__r": function($event) {
        _vm.realValue = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showtable === 'myReport'),
      expression: "showtable === 'myReport'"
    }],
    staticClass: "grid-template"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow is-fullwidth"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key), _vm.showSortIcon()
        }
      }
    }, [_c('div', [_vm._v("\n              " + _vm._s(_vm._f("capitalize")(key)) + "\n              ")])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(entry) {
    return _c('tr', _vm._l((_vm.columns), function(key) {
      return _c('td', {
        class: _vm.GetRiskColor(entry[key])
      }, [_vm._v("\n              " + _vm._s(entry[key]) + "\n            ")])
    }), 0)
  }), 0)])])])])
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-container"
  }, [_c('footer', {
    staticClass: "footer",
    class: {
      'content-full': _vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path === '/terms' || _vm.$route.path.indexOf('/onBoardMember') !== -1
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left"
  }, [_c('p', [_vm._v("© 2020 Straticom Technologies R&D, all rights reserved.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-right"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(175),
      "alt": "Site Logo"
    }
  })])
}]}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          Forgot Password\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('p', [_vm._v("\n            Please enter your email and we’ll send you a password re-set.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n              Submit\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
}]}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.animation,
      "mode": "out-in",
      "appear": "",
      "appear-active-class": _vm.transition.enterClass,
      "enter-active-class": _vm.transition.enterClass,
      "leave-active-class": _vm.transition.leaveClass
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realSelected),
      expression: "realSelected"
    }],
    class: _vm.classObject,
    attrs: {
      "role": "tabpanel",
      "aria-labelledby": _vm.label,
      "aria-hidden": _vm.hidden
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  }, [_vm._v("Add New Client")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }],
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 3rem 1rem"
    }
  }, [_c('form', {
    attrs: {
      "id": "formValue"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Client Information")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.companyName),
      expression: "client.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Client Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "companyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.url),
      expression: "client.url"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.client.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "logo",
      "id": "logo"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange()
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff",
      "max-width": "6em !important"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.pictureName ? _vm.pictureName : 'Client Logo') + "\n                  ")])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Minimum size: width 200px * height 40px")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.firstName),
      expression: "client.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "First Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.lastName),
      expression: "client.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Last Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email),
      expression: "client.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.phone),
      expression: "client.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.client.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.userRole),
      expression: "client.userRole"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Role"
    },
    domProps: {
      "value": (_vm.client.userRole)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "userRole", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.password),
      expression: "client.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addClient()
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.clients.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.clients), function(item, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#/teamInfo"
      }
    }, [_vm._v(_vm._s(item.companyName))])])]), _vm._v(" "), _c('td', {
      staticClass: "is-icon",
      staticStyle: {
        "width": "30px"
      }
    }, [_c('button', {
      staticClass: "button is-primary is-small",
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }, [_vm._v(" Edit")])])]), _vm._v(" "), _c('td', {
      staticClass: "is-icon",
      staticStyle: {
        "width": "30px"
      }
    }, [_c('button', {
      staticClass: "button is-danger is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteClient(item)
        }
      }
    }, [_vm._v(" Delete")])])])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Edit Client")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 3rem 1rem"
    }
  }, [_c('form', {
    attrs: {
      "id": "formValue"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Client Information")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.companyName),
      expression: "onEditClient.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Client Name"
    },
    domProps: {
      "value": (_vm.onEditClient.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient, "companyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.websiteURL),
      expression: "onEditClient.websiteURL"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.onEditClient.websiteURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient, "websiteURL", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "logo2",
      "id": "logo2"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange2()
      }
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff",
      "max-width": "6em !important"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.pictureName2 ? _vm.pictureName2 : 'Client Logo') + "\n                      ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.firstName),
      expression: "onEditClient.contactPerson.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.lastName),
      expression: "onEditClient.contactPerson.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.role),
      expression: "onEditClient.contactPerson.role"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Role"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.role)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "role", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.email),
      expression: "onEditClient.contactPerson.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.phone),
      expression: "onEditClient.contactPerson.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "phone", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editClient()
      }
    }
  }, [_vm._v("Save changes")])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n        Manage Client(s)\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                      upload logo\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password",
      "required": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("Client Name")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                          upload a logo…\n                        ")])])
}]}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.classObject,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('nav', {
    staticClass: "navbar is-transparent"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path === '/terms' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path==='/terms' || $route.path.indexOf('/onBoardMember') !== -1)? false : true"
    }],
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebarOpen),
      expression: "!sidebarOpen"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarOpen),
      expression: "sidebarOpen"
    }],
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "17.5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/terms') ? true : false),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path.indexOf('/resetPassword') !== -1|| $route.path==='/login' || $route.path==='/terms')? true : false"
    }],
    attrs: {
      "href": "http://www.changevu.com"
    }
  }, [_c('img', {
    staticClass: "sitelogo",
    attrs: {
      "src": __webpack_require__(334),
      "alt": "Site Logo"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/terms') ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path.indexOf('/resetPassword') !== -1|| $route.path==='/login' || $route.path==='/terms')? false : true"
    }],
    attrs: {
      "href": "/#"
    }
  }, [_c('img', {
    staticClass: "company-logo",
    attrs: {
      "src": _vm.clientLogoSrc,
      "alt": "Site Logo"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? true : false),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1)? true : false"
    }],
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.showOutNav
    },
    attrs: {
      "data-target": "navMenu"
    },
    on: {
      "click": function($event) {
        _vm.showOutNav = !_vm.showOutNav
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path === '/terms') ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? false : true"
    }],
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "data-target": "navMenu"
    },
    on: {
      "click": function($event) {
        return _vm.userMenuToggle()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path === '/terms') ? true : false),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? true : false"
    }],
    staticClass: "navbar-menu outNavMenu",
    class: {
      'is-active': _vm.showOutNav
    },
    attrs: {
      "id": "navMenu"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path === '/terms') ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? false : true"
    }],
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "id": "navMenu"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('a', {
    staticClass: "upgradeLink",
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("\n            Upgrade to Pro\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item has-dropdown",
    class: {
      'is-hoverable': _vm.hover
    },
    on: {
      "mouseover": function($event) {
        return _vm.addHover()
      },
      "mouseleave": function($event) {
        return _vm.removeHover()
      }
    }
  }, [_c('a', {
    staticClass: "navbar-link is-active"
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.userImageSrc,
      "alt": "User"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.currentUserName) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown user-menu"
  }, [(_vm.$cookie.get('role') === 'superAdmin') ? _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/admin"
    }
  }, [_vm._v("ChangeVU Admin")])]) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin') ? _c('hr', {
    staticClass: "navbar-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Manage Team Member(s)")])]) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('hr', {
    staticClass: "navbar-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/assessmentInfo"
    }
  }, [_vm._v("Manage Assessment")])]) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('hr', {
    staticClass: "navbar-divider"
  }) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "notification notificationModal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upgrade.email),
      expression: "upgrade.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.upgrade.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.upgrade, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "additionalComment"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Additional Comments")]), _vm._v(" "), _c('div', {
    staticClass: "select",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upgrade.info),
      expression: "upgrade.info"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.upgrade, "info", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Information on")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infoRiskLicense"
    }
  }, [_vm._v("Change Risk teams license")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infoLicense"
    }
  }, [_vm._v("ChangeVU application license")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "changePlatform"
    }
  }, [_vm._v("ChangeVU platform")])])])]), _vm._v(" "), (_vm.upgrade.info) ? _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upgrade.message),
      expression: "upgrade.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Write something..."
    },
    domProps: {
      "value": (_vm.upgrade.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.upgrade, "message", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "buttons has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitUpgrade()
      }
    }
  }, [_vm._v("\n              Send\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("\n            Already have a free trial account?\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/accountSetting"
    }
  }, [_vm._v("Account Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title has-text-centered has-text-primary"
  }, [_c('b', [_vm._v("Want to upgrade to the Pro version?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("\n          Fully automated change risk and mitigation planning for teams\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          No limit on number of assessments\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Create your unique implementation team success profile\n        ")])]), _vm._v(" "), _c('h5', {
    staticClass: "is-title"
  }, [_vm._v("\n        Enable teams to reduce change risk rapidly and more successfully.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
}]}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow": "auto",
      "margin-top": "2rem"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-half-tablet is-one-third-desktop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    attrs: {
      "id": "fromData"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("Welcome to ChangeVU!")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add and confirm your password to complete your account set up.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your first name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your last name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "confirmPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox help has-text-grey"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.agree),
      expression: "user.agree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.agree) ? _vm._i(_vm.user.agree, null) > -1 : (_vm.user.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "agree", $$c)
        }
      }
    }
  }), _vm._v("\n                  I agree to the "), _c('a', {
    attrs: {
      "href": "#/terms",
      "target": "_blank"
    }
  }, [_vm._v("ChangeVU Terms of Use")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control progress-btn"
  }, [(!_vm.isInvited) ? _c('span', [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("Already have an account?")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-primary btnRight",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard()
      }
    }
  }, [_vm._v("Done "), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v("& Do My Assessment")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-centered has-text-white"
  }, [_c('span', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("FREE TRIAL! TEAM CHANGE RISK ASSESSMENT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          Reset Password\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Retype Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rePassword),
      expression: "rePassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rePassword = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n              Submit\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
}]}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "color": "#6666ff",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n        Welcome to the Member edit page. From here you can add, modify or delete Team Member information. Simply click any of the highlighted fields. If you have any questions, "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.contactModal()
      }
    }
  }, [_vm._v("send us a message")]), _vm._v(" and we’ll be right with you\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 1rem 1rem",
      "border": "1px solid whitesmoke",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Invite member by entering email address below")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.members[0].email),
      expression: "members[0].email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter email",
      "disabled": _vm.displayMembers.length > 10
    },
    domProps: {
      "value": (_vm.members[0].email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.members[0], "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control has-text-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.inviteModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Email Preview\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.members[0].email !== '') ? _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addUser()
      }
    }
  }, [_vm._v("Invite Member")])]) : _vm._e(), _vm._v(" "), (_vm.members[0].email === '') ? _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Invite Member")])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMembers.length > 10),
      expression: "displayMembers.length > 10"
    }]
  }, [_vm._v("\n        You can add a maximum of 10 team members in the free risk assessment. "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.contactModal()
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(" to upgrade.\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.displayMembers.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "table-responsive invitedMemberTable"
  }, [_c('small', {
    staticClass: "has-text-grey-light is-pulled-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.remindModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Reminder Preview\n          ")])]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.displayMembers), function(item, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', [_vm._v("\n                " + _vm._s(item.member) + "\n              ")]), _vm._v(" "), (item.status === 1) ? _c('td', [_vm._m(2, true), _vm._v("\n                Invited (not joined)\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 2) ? _c('td', [_vm._m(3, true), _vm._v("\n                Assessment pending\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 3) ? _c('td', [_vm._m(4, true), _vm._v("\n                Assessment Submitted\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "is-icon"
    }, [(item.role === 'TL' || item.status === 3) ? _c('button', {
      staticClass: "button is-primary is-small",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-bell"
    }, [_vm._v(" Remind")])]) : _vm._e(), _vm._v(" "), (item.role !== 'TL' && item.status !== 3) ? _c('button', {
      staticClass: "button is-primary is-small"
    }, [_c('i', {
      staticClass: "fa fa-bell",
      on: {
        "click": function($event) {
          return _vm.remind(item)
        }
      }
    }, [_vm._v(" Remind")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "is-icon",
      staticStyle: {
        "width": "30px"
      }
    }, [(item.role !== 'TL') ? _c('button', {
      staticClass: "button is-danger is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteUser(item)
        }
      }
    }, [_vm._v(" Remove")])]) : _vm._e(), _vm._v(" "), (item.role === 'TL') ? _c('button', {
      staticClass: "button is-danger is-small",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }, [_vm._v(" Remove")])]) : _vm._e()])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal contactModal",
    class: {
      isActive: _vm.contactModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n              Contact Us\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeContactModal()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "3",
      "placeholder": "Your Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.contactSubmit()
      }
    }
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (!_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(5)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal inviteModal",
    class: {
      isActive: _vm.inviteModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeInviteModal()
      }
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n                You've been invited to join ChangeVU's change risk assessment.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(this.user.firstName + ' ' + this.user.lastName) + " invited you to run a team change risk assessment.\n              ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("\n                You have until " + _vm._s(this.initiative.deadline) + " to complete the assessment.\n                ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.user.firstName) + " " + _vm._s(this.user.lastName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.name))])])])])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal remindModal",
    class: {
      isActive: _vm.remindModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeRemindModal()
      }
    }
  })]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n                Reminder: Change Risk Assessment\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Hi there,\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                 You've been invited by " + _vm._s(this.initiative.teamLead) + " to a free change risk assessment."), _c('br'), _vm._v("\n                 The deadline for completing the assessment is " + _vm._s(this.initiative.deadline) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Click the button below to login and run your assessment.\n              ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0rem !important"
    }
  }, [_vm._v("\n                Your team details:\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamLead))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.name))])])])])])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n        Manage Member(s)\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "250px"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#b5b5b5"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#fce473"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon has-text-primary"
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Send")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/changeLeaders.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                Click the link below to accept the invitation."), _c('br'), _vm._v("\n                Validate your email and password to access the change risk assessment.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Accept Invitation")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                Welcome to ChangeVU!"), _c('br'), _c('br'), _vm._v("\n                Thanks,"), _c('br'), _vm._v("ChangeVU Team\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n              Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n              © 2020 Straticom Technologies R&D, all rights reserved.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/blogs.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Run Assessment")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                If you have any questions "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Click here.")]), _c('br'), _c('br'), _vm._v("\n                Thanks,"), _c('br'), _vm._v("ChangeVU Team\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n              Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n              © 2020 Straticom Technologies R&D, all rights reserved.\n            ")])])
}]}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progressBar"
  }, [_c('p', [_vm._v("dfs")])])
}]}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "color": "#6666ff",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "is-fullhd"
  }, [(_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_c('chart', {
    attrs: {
      "id": "summyryChart",
      "type": 'bar',
      "data": _vm.chartData,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7"
  }, [_c('div', {
    staticClass: "table-container teamSummaryTable"
  }, [_c('small', {
    staticClass: "has-text-grey-light is-pulled-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.previewModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Reminder Preview\n                  ")])]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-narrow is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedMembers), function(member) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(member.member) + "\n                      ")]), _vm._v(" "), (member.status === 1) ? _c('td', [_vm._m(2, true), _vm._v("\n                        Invited (not joined)\n                      ")]) : _vm._e(), _vm._v(" "), (member.status === 2) ? _c('td', [_vm._m(3, true), _vm._v("\n                        Assessment pending\n                      ")]) : _vm._e(), _vm._v(" "), (member.status === 3) ? _c('td', [_vm._m(4, true), _vm._v("\n                        Assessment Submitted\n                      ")]) : _vm._e(), _vm._v(" "), (member.action) ? _c('td', [_c('button', {
      staticClass: "button is-primary is-small"
    }, [_c('i', {
      staticClass: "fa fa-bell",
      on: {
        "click": function($event) {
          return _vm.remind(member)
        }
      }
    }, [_vm._v(" Remind")])])]) : _vm._e(), _vm._v(" "), (!member.action) ? _c('td', [_vm._m(5, true)]) : _vm._e()])
  }), 0)])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n              Assessment Dashboard\n            ")]), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('button', {
    staticClass: "button is-primary is-outlined editInitiativeBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editInitiative()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v(" Edit")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "table-container initiativeSummaryTable"
  }, [_c('table', {
    staticClass: "table is-bordered is-narrow is-fullwidth"
  }, [_c('tbody', [_c('tr', [_vm._m(6), _vm._v(" "), (!this.user.Submitted) ? _c('td', [_vm._m(7), _vm._v("\n                      Assessment pending - \n                      "), _c('a', {
    attrs: {
      "href": "/#/ChangeRiskAssessment"
    }
  }, [_vm._v("Do my Assessment")])]) : _vm._e(), _vm._v(" "), (this.user.Submitted) ? _c('td', [_vm._m(8), _vm._v("\n                      Assessment Submitted\n                  ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.deadline) + "\n                    ")])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.teamName) + "\n                  ")])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.teamLead) + "\n                  ")])]), _vm._v(" "), _c('tr', [_vm._m(12), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.name) + "\n                  ")])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.initiativeDetails) + "\n                    "), ((_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') && !this.initiative.initiativeDetails) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editInitiative()
      }
    }
  }, [_vm._v("Update initiative description")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_vm._m(14), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.client.companyName) + "  \n                    "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editInitiative()
      }
    }
  }, [_vm._v("Change logo")]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal welcomeModal",
    class: {
      isActive: _vm.notVisited
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n            Welcome to ChangeVU Free Trial\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeNotVisited()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n          Welcome to ChangeVU’s implementation change risk assessment!\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Please note that you should complete your assessment without consultation with any of your team members!\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Thank you for using ChangeVU!\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal previewModal",
    class: {
      isActive: _vm.previewModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closePreviewModal()
      }
    }
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n              Reminder: Change Risk Assessment\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Hi there,\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n               You've been invited by " + _vm._s(this.initiative.teamLead) + " to a free change risk assessment."), _c('br'), _vm._v("\n               The deadline for completing the assessment is " + _vm._s(this.initiative.deadline) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Click the button below to login and run your assessment.\n            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0rem !important"
    }
  }, [_vm._v("\n              Your team details:\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamLead))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.name))])])])])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary teamMemberTitle"
  }, [_vm._v("\n              Team Member Dashboard\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-outlined editTeamBtn",
    attrs: {
      "href": "/#/teamInfo"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v(" Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#b5b5b5"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#fce473"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon has-text-primary"
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary is-small",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }, [_vm._v(" Remind")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#fce473"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#6666ff"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Due Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Team")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Team Lead")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Initiative")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Organization")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/blogs.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Run Assessment")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              If you have any questions "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Click here.")]), _c('br'), _c('br'), _vm._v("\n              Thanks,"), _c('br'), _vm._v("ChangeVU Team\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n            Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n            © 2020 Straticom Technologies R&D, all rights reserved.\n          ")])])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path === '/terms' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword' || $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path==='/terms' || $route.path.indexOf('/onBoardMember') !== -1)? false : true"
    }],
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/home') ? false : true),
      expression: "($route.path==='/home')? false : true"
    }],
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/home') ? true : false),
      expression: "($route.path==='/home')? true : false"
    }],
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_vm._m(0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_vm._v("\n        " + _vm._s(_vm.msgToUser) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "/home"
    }
  }, [_vm._v("Home")])])])
}]}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path === '/terms' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1|| $route.path==='/login' || $route.path==='/onBoard' || $route.path==='/terms' || $route.path.indexOf('/onBoardMember') !== -1)? false : true"
    }],
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.sidebarShow, slideOutLeft: !_vm.sidebarShow
    }
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n          " + _vm._s(item.meta.label || item.name) + "\n          "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n          " + _vm._s(item.meta.label || item.name) + "\n          "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        class: ['fa', subItem.meta.icon]
      })]), _vm._v("\n                " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n              ")])], 1) : _vm._e()
    }), 0)]) : _vm._e()], 1)
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          Let's Talk\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactInfo.name),
      expression: "contactInfo.name"
    }],
    staticClass: "input",
    attrs: {
      "name": "Name",
      "type": "text",
      "placeholder": "Your Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactInfo, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactInfo.email),
      expression: "contactInfo.email"
    }],
    staticClass: "input",
    attrs: {
      "name": "Email",
      "type": "email",
      "placeholder": "Your Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactInfo, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('p', {
    staticClass: "help is-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "email-invalid"
    }
  }, [_vm._v("This email is invalid")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactInfo.phoneNumber),
      expression: "contactInfo.phoneNumber"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your Phone Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactInfo.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactInfo, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon dateInput"
  }, [_c('datetime', {
    attrs: {
      "min-datetime": new Date().toISOString(),
      "use12-hour": true,
      "type": "datetime",
      "minute-step": 15,
      "auto": true,
      "format": {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      },
      "placeholder": _vm.datePlaceholder
    },
    model: {
      value: (_vm.contactInfo.time),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "time", $$v)
      },
      expression: "contactInfo.time"
    }
  }), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactInfo.details),
      expression: "contactInfo.details"
    }],
    staticClass: "textarea",
    attrs: {
      "name": "Message",
      "placeholder": "Tell us what's on your mind...",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactInfo.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactInfo, "details", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "id": "submit2",
      "disabled": _vm.submitOnProcess
    },
    on: {
      "click": function($event) {
        return _vm.submitContactForm()
      }
    }
  }, [_vm._v(" Send")])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-phone-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
}]}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-margin': _vm.sidebar
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "disable-select",
    class: {
      'backgroundImg': _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? true : false),
      expression: "($route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1)? true : false"
    }],
    staticClass: "backgroundUpperLayer"
  }), _vm._v(" "), _c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true,
      "expand": _vm.sidebar,
      "sidebar": _vm.sidebar
    },
    on: {
      "update:sidebar": function($event) {
        _vm.sidebar = $event
      }
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "sidebarShow": _vm.sidebar,
      "sidebar": _vm.sidebar
    },
    on: {
      "update:sidebar": function($event) {
        _vm.sidebar = $event
      }
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)])
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    class: {
      'content-full': _vm.$route.path === '/' || _vm.$route.path === '/terms' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1
    }
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content",
    class: {
      'landing-full': _vm.$route.path === '/'
    }
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: {
        'is-active': tab.isActive
      }
    }, [_c('a', {
      domProps: {
        "innerHTML": _vm._s(tab.header)
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(tab)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n        ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tab-details"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'vue-bulma-tabs': true
    }, _obj[("is-layout-" + _vm.layout)] = true, _obj )
  }, [_c('div', {
    class: ( _obj$1 = {
      tabs: true
    }, _obj$1[("is-" + _vm.size)] = _vm.size, _obj$1[("is-" + _vm.alignment)] = _vm.alignment, _obj$1[("is-" + _vm.type)] = _vm.type, _obj$1['is-fullwidth'] =  _vm.isFullwidth, _obj$1 )
  }, [_vm._t("left-tab-list"), _vm._v(" "), _c('tab-list', _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActived(index), 'is-disabled': tab.disabled, 'is-flex': true
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.isActived(index) ? 'true' : 'false',
        "aria-expanded": _vm.isActived(index) ? 'true' : 'false',
        "aria-disabled": tab.disabled ? 'true' : 'false',
        "selected": _vm.isActived(index),
        "disabled": tab.disabled
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('a', {
      staticClass: "is-unselectable"
    }, [(tab.icon) ? _c('span', {
      class: ['icon', {
        'is-small': _vm.size !== 'large'
      }]
    }, [_c('i', {
      class: tab.icon
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  }), 0), _vm._v(" "), _vm._t("right-tab-list")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          ChangeVU Free Trial Login\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "name@example.com"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/forgotPassword"
    }
  }, [_vm._v("Forgot Password")])])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow": "auto"
    },
    style: (_vm.modalOpen === true ? 'margin-top: 12rem' : 'margin-top: 2rem')
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-half-tablet is-one-third-desktop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    attrs: {
      "id": "fromData"
    }
  }, [(_vm.step === 1) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("\n              Welcome to ChangeVU!\n            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your email")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "name@example.com"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox help has-text-grey"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.agree),
      expression: "user.agree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.agree) ? _vm._i(_vm.user.agree, null) > -1 : (_vm.user.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "agree", $$c)
        }
      }
    }
  }), _vm._v("\n                  I agree to the "), _c('a', {
    attrs: {
      "href": "#/terms",
      "target": "_blank"
    }
  }, [_vm._v("ChangeVU Terms of Use")])])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("Check your email!")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              We've sent a 6-digit confirmation code to "), _c('strong', [_vm._v(_vm._s(this.user.email))]), _vm._v(". It will expire shortly, so enter it soon.\n            ")]), _vm._v(" "), _c('Sms', {
    model: {
      value: (_vm.verificationDigits),
      callback: function($$v) {
        _vm.verificationDigits = $$v
      },
      expression: "verificationDigits"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "intro-text has-text-grey-light"
  }, [_vm._v("\n              Keep this window open while checking for your code. Remember to try your spam folder!\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("Your email is verified!")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add and confirm your password to complete your account set up.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your first name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your last name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "confirmPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(6)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("\n              Two more steps!\n            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Organization name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.companyName),
      expression: "client.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Organization name"
    },
    domProps: {
      "value": (_vm.client.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your team name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.teamName),
      expression: "initiative.teamName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your team name"
    },
    domProps: {
      "value": (_vm.initiative.teamName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "teamName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                Initiative name\n                "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Please add initiative, project or other program name.'),
      expression: "'Please add initiative, project or other program name.'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.initiativeName),
      expression: "initiative.initiativeName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Initiative name"
    },
    domProps: {
      "value": (_vm.initiative.initiativeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "initiativeName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                Assessment due date\n                "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Date to complete assessment for all members.'),
      expression: "'Date to complete assessment for all members.'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon deadlineInput"
  }, [_c('datetime', {
    attrs: {
      "min-datetime": new Date().toISOString(),
      "max-datetime": new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString(),
      "use12-hour": true,
      "type": "datetime",
      "minute-step": 15,
      "auto": true,
      "format": {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      },
      "placeholder": _vm.datePlaceholder
    },
    model: {
      value: (_vm.initiative.deadline),
      callback: function($$v) {
        _vm.$set(_vm.initiative, "deadline", $$v)
      },
      expression: "initiative.deadline"
    }
  }), _vm._v(" "), _vm._m(11)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("\n              Last step!\n            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "control has-text-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.previewModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Email Preview\n              ")])]), _vm._v(" "), _vm._l((_vm.members), function(input, k) {
    return _c('div', {
      key: k,
      staticClass: "field"
    }, [_c('p', {
      staticClass: "control has-icons-left has-icons-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.members[k].email),
        expression: "members[k].email"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": "name@example.com"
      },
      domProps: {
        "value": (_vm.members[k].email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.members[k], "email", $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('span', {
      staticClass: "icon is-small is-right"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k || (!k && _vm.members.length > 1)),
        expression: "k || ( !k && members.length > 1)"
      }],
      staticClass: "fa fa-times-circle",
      on: {
        "click": function($event) {
          return _vm.remove(k)
        }
      }
    })])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.members.length <= 9),
        expression: "members.length <= 9"
      }],
      staticClass: "control has-text-right"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k === _vm.members.length - 1),
        expression: "k === members.length-1"
      }],
      on: {
        "click": function($event) {
          return _vm.add(k)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    }), _vm._v(" Add another\n                ")])])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.members.length > 9),
      expression: "members.length > 9"
    }],
    staticClass: "help"
  }, [_vm._v("\n              You can add a maximum of 10 team members in the free risk assessment. "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.contactModal()
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(" to upgrade.\n            ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control progress-btn",
    class: {
      'btnCenter': _vm.step !== 1
    }
  }, [(_vm.step === 1) ? _c('span', {
    staticClass: "step1msg"
  }, [_c('p', {
    staticClass: "red"
  }, [_vm._v("No credit card required")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("Already have a free trial account?")])]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(1)
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(2)
      }
    }
  }, [_vm._v("Confirm")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(3)
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('button', {
    staticClass: "button is-primary btnRight",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(4)
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('button', {
    staticClass: "button is-primary btnRight",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(5)
      }
    }
  }, [_vm._v("Done "), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v("& Do My Assessment")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal previewModal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n              You've been invited to join ChangeVU's change risk assessment.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(this.user.firstName) + " invited you to run a team change risk assessment.\n            ")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', [_vm._v("\n              You have until " + _vm._s(this.initiative.deadline) + " to complete the assessment."), _c('br'), _vm._v("\n              You will then receive your individual and team reports.\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.user.firstName) + " " + _vm._s(this.user.lastName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.initiativeName))])])])])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal contactModal",
    class: {
      isActive: _vm.contactModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n              Contact Us\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeContactModal()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "3",
      "placeholder": "Your Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.contactSubmit()
      }
    }
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (!_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(19)]) : _vm._e()])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-centered has-text-white"
  }, [_c('span', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("FREE TRIAL! TEAM CHANGE RISK ASSESSMENT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please enter your email address. "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "grey",
      "font-size": "0.75rem"
    }
  }, [_vm._v("(Your email is safe with us. We will not spam you.)")]), _vm._v(" "), _c('br'), _vm._v("\n              Create your account and assessment date. "), _c('br'), _vm._v("\n              Invite team members & run your free trial!\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add initiative information (below). "), _c('br'), _vm._v("\n              Then add team members (next page)..."), _c('br'), _vm._v("\n              ...and you're ready to go!"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-address-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add your team member’s email addresses."), _c('br'), _vm._v("\n              They will automatically be invited to the assessment.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/changeLeaders.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n              Click the link below to accept the invitation."), _c('br'), _vm._v("\n              Validate your email and password to access the change risk assessment.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Accept Invitation")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              Welcome to ChangeVU!"), _c('br'), _c('br'), _vm._v("\n              Thanks,"), _c('br'), _vm._v("ChangeVU Team\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n            Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n            © 2020 Straticom Technologies R&D, all rights reserved.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Send")])])
}]}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('tabs', {
    attrs: {
      "type": "boxed",
      "size": "medium",
      "id": "generalTab"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "User Info",
      "icon": "fa fa-user"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_vm._v("\n                  " + _vm._s(this.userInfo.email) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfo.firstName),
      expression: "userInfo.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userInfo.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfo, "firstName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfo.lastName),
      expression: "userInfo.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userInfo.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfo, "lastName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "profilePicture",
      "id": "profilePicture"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                    Choose a file…\n                  ")])]), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.pictureName ? _vm.pictureName : 'Profile Picture') + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.editUser()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t      Submit\n\t\t\t\t\t    ")])])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Change Password",
      "icon": "fa fa-lock"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Old Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Re-type New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rePassword),
      expression: "rePassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rePassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.changePassword()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t      Submit\n\t\t\t\t\t    ")])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          Account Settings\n        ")])])
}]}

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports) {

module.exports = {"_from":"weekstart@^1.0.1","_id":"weekstart@1.0.1","_inBundle":false,"_integrity":"sha512-h6B1HSJxg7sZEXqIpDqAtwiDBp3x5y2jY8WYcUSBhLTcTCy7laQzBmamqMuQM5fpvo1pgpma0OCRpE2W8xrA9A==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"weekstart@^1.0.1","name":"weekstart","escapedName":"weekstart","rawSpec":"^1.0.1","saveSpec":null,"fetchSpec":"^1.0.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.0.1.tgz","_shasum":"950970b48e5797e06fc1a762f3d0f013312321e1","_spec":"weekstart@^1.0.1","_where":"/Users/mashiyat/Desktop/monist/1HackAsolution/running_Client/changeVu/FreeRiskAssesment/risk-assessment","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"bundleDependencies":false,"deprecated":false,"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"7.6.3","eslint":"6.5.1","eslint-config-guard":"1.0.3","ink-docstrap":"1.3.2","jest":"24.9.0","jsdoc":"3.6.3","microbundle":"0.4.4","version-bump-prompt":"5.0.5"},"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.json","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.0.1"}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(174);


/***/ })
],[397]);


// WEBPACK FOOTER //
// assets/js/app.57a3ac24dafe8ac3c025.js